(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __moduleCache = /* @__PURE__ */ new WeakMap;
  var __toCommonJS = (from) => {
    var entry = __moduleCache.get(from), desc;
    if (entry)
      return entry;
    entry = __defProp({}, "__esModule", { value: true });
    if (from && typeof from === "object" || typeof from === "function")
      __getOwnPropNames(from).map((key) => !__hasOwnProp.call(entry, key) && __defProp(entry, key, {
        get: () => from[key],
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
      }));
    __moduleCache.set(from, entry);
    return entry;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, {
        get: all[name],
        enumerable: true,
        configurable: true,
        set: (newValue) => all[name] = () => newValue
      });
  };

  // ../lyquix/js/lyquix.ts
  var exports_lyquix = {};
  __export(exports_lyquix, {
    default: () => lyquix_default
  });

  // ../lyquix/js/lib/lyquix/core.ts
  var vars = {
    window: jQuery(window),
    document: jQuery(document),
    html: jQuery("html"),
    body: jQuery("body")
  };
  var cfg = {
    debug: 0,
    siteURL: (() => {
      let url = jQuery('script[src*="wp-content/themes/lyquix"], script[src*="wp-content/themes/wp_theme_lyquix"]').first().attr("src") || jQuery('link[href*="wp-content/themes/lyquix"], link[href*="wp-content/themes/wp_theme_lyquix"]').first().attr("href") || "";
      if (!url)
        return null;
      url = new URL(url, window.location.href).href;
      return url.slice(0, url.indexOf("wp-content/themes/"));
    })(),
    tmplURL: (() => {
      let url = jQuery('script[src*="wp-content/themes/lyquix"], script[src*="wp-content/themes/wp_theme_lyquix"]').attr("src") || jQuery('link[href*="wp-content/themes/lyquix"], link[href*="wp-content/themes/wp_theme_lyquix"]').attr("href") || "";
      if (!url)
        return null;
      url = new URL(url, window.location.href).href;
      const themeNameStart = url.indexOf("wp-content/themes/") + "wp-content/themes/".length;
      const themeNameEnd = url.indexOf("/", themeNameStart);
      return url.slice(0, themeNameEnd + 1);
    })()
  };
  function log(...args) {
    if (cfg.debug > 2) {
      window.console.log(...args);
    }
  }
  function warn2(...args) {
    if (cfg.debug > 1) {
      window.console.warn(...args);
    }
  }
  function error(...args) {
    if (cfg.debug > 0) {
      window.console.error(...args);
    }
  }

  // ../lyquix/js/lib/lyquix/mutation.ts
  var mutation = (() => {
    const init = (customCfg) => {
      if (vars.mutation?.init)
        return;
      vars.mutation = {
        init: false,
        observer: null,
        addNode: [],
        removeNode: [],
        modAttrib: []
      };
      cfg.mutation = {
        enabled: true
      };
      if (customCfg)
        cfg.mutation = jQuery.extend(true, cfg.mutation, customCfg);
      if (cfg.mutation.enabled) {
        log("Initializing mutation");
        const mo = window.MutationObserver;
        if (typeof mo !== "undefined") {
          vars.mutation.observer = new mo(handler);
          vars.mutation.observer.observe(document.body, { childList: true, subtree: true, attributes: true });
        }
      }
      vars.mutation.init = true;
    };
    const addHandler = (type, selector, callback) => {
      if (!(type in vars.mutation) || !Array.isArray(vars.mutation[type])) {
        warn2("Invalid mutation handler type", type);
        return;
      }
      if (typeof selector !== "string" || typeof callback !== "function") {
        warn2("Invalid mutation handler selector or callback", selector);
        return;
      }
      vars.mutation[type].push({ selector, callback });
      log("Adding handler for mutation " + type + " for " + selector);
    };
    const handler = (mutRecs) => {
      if (!(mutRecs instanceof Array)) {
        mutRecs = [mutRecs];
      }
      mutRecs.forEach((mutRec) => {
        switch (mutRec.type) {
          case "childList": {
            if (mutRec.addedNodes.length > 0) {
              const nodes = nodesArray(mutRec.addedNodes);
              nodes.forEach((e) => {
                vars.mutation.addNode.forEach((h) => {
                  if (jQuery(e).is(h.selector))
                    h.callback(e);
                });
              });
            }
            if (mutRec.removedNodes.length > 0) {
              const nodes = nodesArray(mutRec.removedNodes);
              nodes.forEach((e) => {
                vars.mutation.removeNode.forEach((h) => {
                  if (jQuery(e).is(h.selector))
                    h.callback(e);
                });
              });
            }
            break;
          }
          case "attributes":
            vars.mutation.modAttrib.forEach((h) => {
              if (mutRec.target.matches(h.selector))
                h.callback(mutRec.target);
            });
            break;
        }
      });
    };
    const nodesArray = (nodes) => {
      let o = [];
      for (let i = 0;i < nodes.length; i++) {
        const n = jQuery(nodes[i]);
        o.push(n);
        const children = n.find("*").toArray();
        if (children.length)
          o = o.concat(children);
      }
      return o;
    };
    return {
      init,
      addHandler
    };
  })();

  // ../lyquix/js/lib/lyquix/util.ts
  var util = (() => {
    const init = (customCfg) => {
      if (vars.util?.init)
        return;
      vars.util = {
        init: false
      };
      cfg.util = {
        enabled: true
      };
      if (customCfg)
        cfg.util = jQuery.extend(true, cfg.util, customCfg);
      if (cfg.util.enabled) {
        log("Initializing util");
      }
      vars.util.init = true;
    };
    const cookie = (name, value, attributes) => {
      if (!name && !value && !attributes)
        return false;
      if (!value && !attributes) {
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(name).replace(/[-\\.+*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
      }
      let c = encodeURIComponent(name) + "=" + encodeURIComponent(value);
      if (typeof attributes == "object") {
        if ("maxAge" in attributes)
          c += "; max-age=" + parseInt(attributes.maxAge);
        if ("expires" in attributes && attributes.expires instanceof Date)
          c += "; expires=" + attributes.expires.toUTCString();
        if ("path" in attributes)
          c += "; path=" + attributes.path;
        if ("domain" in attributes)
          c += "; domain=" + attributes.domain;
        if ("secure" in attributes)
          c += "; secure";
        if ("httpOnly" in attributes)
          c += "; httponly";
      }
      document.cookie = c;
      return true;
    };
    const getVideoUrls = (url) => {
      let match, youtubeId, vimeoId, thumbnail;
      const youtubeRegex = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|live\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
      const vimeoRegex = /^https?:\/\/(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)$/;
      if (match = url.match(youtubeRegex)) {
        youtubeId = match[1];
        if (youtubeId) {
          url = "https://www.youtube.com/embed/" + youtubeId + "?rel=0&amp;autoplay=1&amp;mute=1&amp;modestbranding=1";
          thumbnail = "https://img.youtube.com/vi/" + youtubeId + "/hqdefault.jpg";
        }
      } else if (match = url.match(vimeoRegex)) {
        vimeoId = match[1];
        if (vimeoId) {
          url = "https://player.vimeo.com/video/" + vimeoId;
          thumbnail = "https://vumbnail.com/" + vimeoId + ".jpg";
        }
      } else {
        url = "";
        thumbnail = "";
      }
      return { url, thumbnail };
    };
    const hash = (str) => {
      const FNV_PRIME = 16777619;
      const h = [2166136261, 90739405, 1802186063, 1166963592];
      str += "t%V7t6Bu0^sN5zrjAZF*%eAVd49H0DhL";
      for (let i = 0;i < str.length; i++) {
        for (let j = 0;j < 4; j++) {
          if (j == 0)
            h[j] ^= str.charCodeAt(i);
          else
            h[j] ^= h[j - 1];
          h[j] *= FNV_PRIME;
        }
      }
      return h.map((v) => (v >>> 0).toString(16).padStart(8, "0")).join("");
    };
    const parseUrlParams = (url) => {
      const urlParams = {};
      const queryStr = new URL(url, window.location.href).search.substr(1);
      if (queryStr != "") {
        const params = queryStr.split("&");
        if (params.length) {
          params.forEach((param) => {
            const pair = param.split("=", 2);
            if (pair.length == 2)
              urlParams[pair[0]] = decodeURIComponent(pair[1].replace(/\+/g, " "));
            else
              urlParams[pair[0]] = null;
          });
        }
      }
      return urlParams;
    };
    const randomStr = (len) => {
      let str = parseInt((Math.random() * 100000000000000000).toString()).toString(36);
      if (typeof len == "number") {
        while (str.length < len)
          str += parseInt((Math.random() * 100000000000000000).toString()).toString(36);
        return str.substring(0, len);
      }
      return str;
    };
    const slugify = (str, delimiter = "-") => {
      let slug = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      slug = str.replace(/[^a-zA-Z0-9\s-]/g, "");
      slug = slug.replace(/\s+/g, delimiter);
      slug = slug.toLowerCase();
      slug = slug.replace(new RegExp(`^${delimiter}|${delimiter}$`, "g"), "");
      return slug;
    };
    const timeStr = () => {
      return new Date().getTime().toString(36);
    };
    const uniqueStr = (len) => {
      return timeStr() + randomStr(len);
    };
    const uniqueUrl = (sel, attrib) => {
      const elems = jQuery(sel);
      if (elems.length) {
        log(`Setting unique URLs in ${attrib} for ${sel} ${elems.length} elements`);
        elems.each((index, elem) => {
          const url = jQuery(elem).attr(attrib);
          if (typeof url != "undefined") {
            jQuery(elem).attr(attrib, url + (url.indexOf("?") !== -1 ? "&" : "?") + uniqueStr());
          }
        });
      }
    };
    const getDataType = (data) => {
      let type = typeof data;
      switch (type) {
        case "boolean":
        case "string":
          break;
        case "bigint":
          type = "integer";
          break;
        case "number":
          if (data % 1 === 0)
            type = "integer";
          else
            type = "float";
          break;
        case "object":
          if (Array.isArray(data))
            type = "array";
          break;
        default:
          type = "";
      }
      return type;
    };
    const validateData = (data, schema, field = "root") => {
      const missing = [];
      const mistyped = [];
      const invalid = [];
      const fixed = [];
      let isValid = true;
      let isFixed = false;
      Object.keys(schema).forEach((key) => {
        switch (key) {
          case "type":
            if (!["string", "integer", "float", "boolean", "array", "object"].includes(schema.type)) {
              error(`validateData: invalid type ${schema.type} in schema`, schema);
              return false;
            }
            break;
          case "required":
            if (typeof schema.required !== "boolean") {
              error("validateData: invalid required value in schema", schema);
            }
            break;
          case "default":
            break;
          case "keys":
            if (typeof schema.keys !== "object") {
              error("validateData: invalid keys value in schema", schema);
            }
            break;
          case "elems":
            if (typeof schema.elems !== "object") {
              error("validateData: invalid elems value in schema", schema);
            }
            break;
          case "allowed":
            if (!Array.isArray(schema.allowed)) {
              error("validateData: invalid allowed value in schema", schema);
            }
            if (schema.allowed.length === 0) {
              error("validateData: empty allowed value in schema", schema);
            }
            break;
          case "range":
            if (!Array.isArray(schema.range) || schema.range.length !== 2) {
              error("validateData: invalid range value in schema", schema);
            }
            if (schema.range[0] === null && typeof schema.range[1] !== "number") {
              error("validateData: both range values are null in schema", schema);
            }
            if (schema.range[1] === null && typeof schema.range[0] !== "number") {
              error("validateData: both range values are null in schema", schema);
            }
            break;
          case "match":
            if (!(schema.match instanceof RegExp)) {
              error("validateData: invalid match value in schema", schema);
            }
            break;
          default:
            error(`validateData: unexpected key ${key} in schema`, schema);
        }
      });
      if (!("type" in schema)) {
        error("validateData: missing type in schema", schema);
      }
      if (!("required" in schema))
        schema["required"] = false;
      if (getDataType(data) !== schema.type) {
        switch (schema.type) {
          case "string":
            if (typeof data === "number" || typeof data === "bigint") {
              data = data.toString();
              isFixed = true;
            } else if (typeof data === "boolean") {
              data = data ? "true" : "false";
              isFixed = true;
            }
            break;
          case "integer":
            if (!isNaN(data) && parseInt(data) == parseFloat(data)) {
              data = parseInt(data);
              isFixed = true;
            }
            break;
          case "float":
            if (!isNaN(data)) {
              data = parseFloat(data);
              isFixed = true;
            }
            break;
          case "boolean":
            if (data === 0 || data === "0" || data === "false") {
              data = false;
              isFixed = true;
            }
            if (data === 1 || data === "1" || data === "true") {
              data = true;
              isFixed = true;
            }
            break;
        }
      }
      if (getDataType(data) !== schema.type) {
        mistyped.push(field);
        if ("default" in schema) {
          data = schema.default;
          fixed.push(field);
          isFixed = true;
        } else {
          isValid = false;
        }
      } else {
        if (["string", "integer", "float"].includes(schema.type)) {
          if ("allowed" in schema) {
            if (!schema.allowed.includes(data)) {
              invalid.push(field);
              if ("default" in schema) {
                data = schema.default;
                fixed.push(field);
                isFixed = true;
              } else {
                isValid = false;
              }
            }
          }
        }
        if (["integer", "float"].includes(schema.type)) {
          if ("range" in schema) {
            const min = schema.range[0];
            const max = schema.range[1];
            if (min === null && !isNaN(max) && data > max || max === null && !isNaN(min) && data < min || !isNaN(min) && !isNaN(max) && (data < min || data > max)) {
              invalid.push(field);
              if ("default" in schema) {
                data = schema.default;
                fixed.push(field);
                isFixed = true;
              } else {
                isValid = false;
              }
            }
          }
        }
        if (schema.type == "string") {
          if ("match" in schema) {
            if (!schema.match.test(data)) {
              invalid.push(field);
              if ("default" in schema) {
                data = schema.default;
                fixed.push(field);
                isFixed = true;
              } else {
                isValid = false;
              }
            }
          }
        }
        if (schema.type === "array") {
          if ("elems" in schema) {
            let arrayResult = [];
            data.forEach((elem, index) => {
              const elemResult = validateData(elem, schema.elems, `${field}[${index}]`);
              if (elemResult !== false) {
                elemResult.missing.forEach((f) => missing.push(f));
                elemResult.mistyped.forEach((f) => mistyped.push(f));
                elemResult.invalid.forEach((f) => invalid.push(f));
                elemResult.fixed.forEach((f) => fixed.push(f));
                if (elemResult.isValid) {
                  if (elemResult.isFixed) {
                    isFixed = true;
                  }
                  arrayResult.push(elemResult.data);
                }
              }
            });
            data = Object.assign([], arrayResult);
          }
        }
        if (schema.type === "object") {
          if ("keys" in schema) {
            for (const key in schema.keys) {
              if (!(key in data)) {
                if (!("required" in schema.keys[key]))
                  schema.keys[key]["required"] = false;
                if (schema.keys[key].required) {
                  missing.push(key);
                  if (schema.keys[key].default !== undefined) {
                    data[key] = schema.keys[key].default;
                    fixed.push(key);
                    isFixed = true;
                  } else {
                    isValid = false;
                    continue;
                  }
                }
              }
              let keyResult = false;
              if (key in data)
                keyResult = validateData(data[key], schema.keys[key], `${field}/${key}`);
              if (keyResult !== false) {
                keyResult.missing.forEach((f) => missing.push(f));
                keyResult.mistyped.forEach((f) => mistyped.push(f));
                keyResult.invalid.forEach((f) => invalid.push(f));
                keyResult.fixed.forEach((f) => fixed.push(f));
                if (keyResult.isValid) {
                  if (keyResult.isFixed) {
                    isFixed = true;
                    data[key] = keyResult.data;
                  }
                } else {
                  isValid = false;
                }
              }
            }
          }
        }
      }
      return {
        isValid,
        isFixed,
        missing,
        mistyped,
        invalid,
        fixed,
        data
      };
    };
    const schemaStr = { type: "string" };
    const schemaStrReq = { type: "string", required: true };
    const schemaStrReqEmp = { type: "string", required: true, default: "" };
    const schemaStrReqNotEmp = { type: "string", required: true, match: /.+/ };
    const schemaStrReqY = { type: "string", required: true, default: "y", allowed: ["y", "n"] };
    const schemaStrReqN = { type: "string", required: true, default: "n", allowed: ["y", "n"] };
    const schemaInt = { type: "integer" };
    const schemaIntReq = { type: "integer", required: true };
    const schemaHexColor = { type: "string", default: "", match: /^#([A-Fa-f0-9]{8}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{4}|[A-Fa-f0-9]{3})$/ };
    const versionCompare = (a, b) => {
      if (a === b)
        return 0;
      a = String(a).split(".");
      b = String(b).split(".");
      const len = Math.min(a.length, b.length);
      for (let i = 0;i < len; i++) {
        if (parseInt(a[i]) > parseInt(b[i]))
          return 1;
        if (parseInt(a[i]) < parseInt(b[i]))
          return -1;
      }
      if (a.length > b.length)
        return 1;
      if (a.length < b.length)
        return -1;
      return 0;
    };
    const addErrorHandler = (newHandler) => {
      const oldHandler = window.onerror || null;
      window.onerror = (message, source, lineno, colno, error2) => {
        if (oldHandler)
          oldHandler(message, source, lineno, colno, error2);
        newHandler(message, source, lineno, colno, error2);
      };
    };
    return {
      init,
      cookie,
      getVideoUrls,
      hash,
      parseUrlParams,
      randomStr,
      slugify,
      timeStr,
      uniqueStr,
      uniqueUrl,
      validateData,
      versionCompare,
      schemaStr,
      schemaStrReq,
      schemaStrReqEmp,
      schemaStrReqNotEmp,
      schemaStrReqY,
      schemaStrReqN,
      schemaInt,
      schemaIntReq,
      schemaHexColor,
      addErrorHandler
    };
  })();

  // ../lyquix/js/lib/lyquix/analytics.ts
  var analytics = (() => {
    const init = (customCfg) => {
      if (vars.analytics?.init)
        return;
      vars.analytics = {
        abTestGroup: null,
        scrollDepthMax: null,
        status: null,
        queue: [],
        youTubeIframeAPIReady: false,
        youtubePlayers: {},
        vimeoPlayers: {},
        userActive: null,
        errorHashes: [],
        clickEvents: []
      };
      cfg.analytics = {
        enabled: true,
        downloads: {
          enabled: true,
          extensions: [
            "gif",
            "png",
            "jpg",
            "jpeg",
            "tif",
            "tiff",
            "svg",
            "webp",
            "bmp",
            "zip",
            "rar",
            "gzip",
            "gz",
            "7z",
            "tar",
            "exe",
            "msi",
            "dmg",
            "dll",
            "txt",
            "log",
            "pdf",
            "rtf",
            "doc",
            "docx",
            "dot",
            "dotx",
            "xls",
            "xlsx",
            "xlt",
            "xltx",
            "ppt",
            "pptx",
            "pot",
            "potx",
            "aac",
            "aiff",
            "mp3",
            "mp4",
            "m4a",
            "m4p",
            "wav",
            "wma",
            "3gp",
            "3g2",
            "mkv",
            "vob",
            "ogv",
            "ogg",
            "webm",
            "wma",
            "m2v",
            "m4v",
            "mpg",
            "mp2",
            "mpeg",
            "mpe",
            "mpv",
            "mov",
            "avi",
            "wmv",
            "flv",
            "f4v",
            "swf",
            "qt",
            "xml",
            "js",
            "json",
            "jsonp",
            "css",
            "less",
            "sass",
            "scss"
          ],
          hitType: "pageview",
          nonInteraction: false
        },
        errors: {
          enabled: false,
          maxErrors: 100
        },
        outbound: {
          enabled: true,
          exclude: [],
          nonInteraction: true
        },
        scrollDepth: {
          enabled: false
        },
        video: {
          enabled: true,
          nonInteraction: false
        },
        userActive: {
          enabled: false,
          idleTime: 5000,
          throttle: 250,
          refresh: 250,
          maxTime: 1800000
        },
        rageClicks: {
          enabled: true,
          minClicks: 3,
          maxTime: 5,
          maxDistance: 100
        },
        performance: {
          enabled: false
        },
        usingGTM: false,
        sendPageview: true,
        measurementId: null,
        abTest: {
          name: null,
          dimension: null,
          split: 0.5,
          removeNoMatch: true,
          cookieDays: 30,
          displaySelector: '[data-abtest], [class*="abtest-"]'
        },
        projectId: null
      };
      if (customCfg)
        cfg.analytics = jQuery.extend(true, cfg.analytics, customCfg);
      if (cfg.analytics.enabled) {
        log("Initializing analytics");
        if (cfg.analytics.measurementId && !cfg.analytics.usingGTM || cfg.analytics.usingGTM) {
          if (cfg.analytics.abTest.name && cfg.analytics.abTest.dimension)
            initABTesting();
          if (!cfg.analytics.usingGTM && cfg.analytics.measurementId) {
            gtagCode(cfg.analytics.measurementId);
          }
          vars.analytics.status = "wait";
          log("Waiting for Google Analytics to be ready");
          checkGA();
          window["onYouTubeIframeAPIReady"] = () => {
            onYouTubeIframeAPIReady();
          };
        } else {
          log("Analytics not available: no measurementId or GTM set");
          vars.analytics.status = "n/a";
        }
        if (cfg.analytics.projectId) {
          clarityCode();
        }
      }
      vars.analytics.init = true;
    };
    const gtagCode = (tagId) => {
      log("Loading Google Analytics code (gtag.js)");
      let ga4Script = document.createElement("script");
      ga4Script.async = true;
      ga4Script.src = "https://www.googletagmanager.com/gtag/js?id=" + tagId;
      document.head.appendChild(ga4Script);
      ga4Script = document.createElement("script");
      ga4Script.innerHTML = `
\t\t\twindow.dataLayer = window.dataLayer || [];
\t\t\tfunction gtag(){dataLayer.push(arguments);}
\t\t\tgtag('js', new Date());` + (vars.analytics.abTestGroup ? `gtag('set', 'dimension' + '${cfg.analytics.abTest.dimension}', '${vars.analytics.abTestGroup}');` : "") + `gtag('config', '${tagId}', ${cfg.analytics.sendPageview ? "{}" : "{'send_page_view': false}"});`;
      document.head.appendChild(ga4Script);
    };
    const clarityCode = () => {
      log("Loading Microsoft Clarity code");
      const clarityScript = document.createElement("script");
      clarityScript.async = true;
      clarityScript.src = `https://www.clarity.ms/tag/${cfg.analytics.projectId}`;
      document.head.appendChild(clarityScript);
    };
    const checkGA = (count) => {
      if (!count)
        count = 0;
      if ("gtag" in window && typeof window["gtag"] == "function") {
        vars.analytics.status = "init";
        initTracking();
      } else if (count < 600)
        setTimeout(() => {
          checkGA(count++);
        }, 100);
      else {
        vars.analytics.status = "n/a";
        error("Google Analytics not available");
        if (vars.analytics.queue.length)
          error("Unable to send queued analytics", vars.analytics.queue);
      }
    };
    const sendGAPageview = (pageInfo) => {
      if (vars.analytics.status == "ready") {
        log("Sending page view to GA", pageInfo);
        if (!pageInfo || typeof pageInfo !== "object") {
          warn2("Invalid pageInfo object", pageInfo);
          return;
        }
        if (pageInfo.url && pageInfo.title) {
          const url = new URL(pageInfo.url, window.location.href);
          const pageParams = {
            page_location: url.href,
            page_path: url.pathname + url.search,
            page_title: pageInfo.title
          };
          if ("callback" in pageInfo)
            pageParams["event_callback"] = pageInfo.callback;
          gtag("event", "page_view", pageParams);
        } else
          gtag("event", "page_view");
      } else if (vars.analytics.status == "wait" || vars.analytics.status == "init") {
        log("Queueing GA pageview to send later", pageInfo);
        vars.analytics.queue.push({ type: "pageview", info: pageInfo });
      } else if (vars.analytics.status == "n/a")
        log("Analytics not available, unable to send GA pageview", pageInfo);
    };
    const sendGAEvent = (eventInfo) => {
      if (vars.analytics.status == "ready") {
        log("Sending event to GA", eventInfo);
        const ga4PropMap = {
          eventCategory: "event_category",
          eventLabel: "event_label",
          eventAction: "event_action",
          eventValue: "value",
          nonInteraction: "non_interaction",
          hitCallback: "event_callback"
        };
        const eventParams = {};
        Object.keys(ga4PropMap).forEach((prop) => {
          if (prop in eventInfo && eventInfo[prop])
            eventParams[ga4PropMap[prop]] = eventInfo[prop];
        });
        if (!eventInfo.eventAction && !eventInfo.eventName) {
          warn2("eventAction or eventName is required", eventInfo);
          return;
        }
        const eventName = "eventName" in eventInfo && eventInfo.eventName ? eventInfo.eventName : eventInfo.eventAction;
        eventParams["event_timeout"] = 2000;
        gtag("event", eventName, eventParams);
      } else if (vars.analytics.status == "wait" || vars.analytics.status == "init") {
        log("Queueing GA event to send later", eventInfo);
        vars.analytics.queue.push({ type: "event", info: eventInfo });
      } else if (vars.analytics.status == "n/a")
        log("Analytics not available, unable to send GA event", eventInfo);
    };
    const initTracking = () => {
      if (cfg.analytics.outbound.enabled || cfg.analytics.downloads.enabled) {
        log("Setting up outbound/download links tracking");
        const setup = (elems) => {
          if (elems instanceof Node) {
            elems = [elems];
          } else if (elems instanceof jQuery) {
            elems = elems.toArray();
          }
          if (elems.length) {
            log("Setting up " + elems.length + " download links", elems);
            elems.forEach((elem) => {
              if (elem.href) {
                elem = jQuery(elem);
                let url;
                try {
                  url = new URL(elem.attr("href"), window.location.href);
                } catch (e) {
                  log(e);
                  return;
                }
                let newWindow = elem.attr("target") && !elem.attr("target").match(/^_(self|parent|top)$/i);
                if (cfg.analytics.outbound.enabled && url.host != window.location.host && cfg.analytics.outbound.exclude.indexOf(url.host) == -1) {
                  log("Found outbound link to " + url.href);
                  elem.on("click", (e) => {
                    log("Outbound link to: " + url.href);
                    newWindow = newWindow || e.ctrlKey || e.shiftKey || e.metaKey;
                    let timer;
                    if (!newWindow)
                      timer = setTimeout(() => {
                        window.location.href = url.href;
                      }, 2000);
                    const label = elem.attr("title") ? elem.attr("title") + " [" + url.href + "]" : url.href;
                    sendGAEvent({
                      eventCategory: "Outbound Links",
                      eventAction: "click",
                      eventLabel: label,
                      nonInteraction: cfg.analytics.outbound.nonInteraction,
                      hitCallback: newWindow ? null : () => {
                        clearTimeout(timer);
                        window.location.href = url.href;
                      }
                    });
                    return newWindow;
                  });
                }
                if (cfg.analytics.downloads.enabled && url.href.match(new RegExp("\\.(" + cfg.analytics.downloads.extensions.join("|") + ")$", "i")) !== null) {
                  log("Found download link to " + url.href);
                  elem.on("click", (e) => {
                    log("Download link to: " + url.href);
                    newWindow = newWindow || e.ctrlKey || e.shiftKey || e.metaKey;
                    let timer;
                    if (!newWindow)
                      timer = setTimeout(() => {
                        window.location.href = url.href;
                      }, 2000);
                    const loc = url.protocol + "//" + url.hostname + url.pathname + url.search;
                    const page = url.pathname + url.search;
                    const title = elem.attr("title") ? elem.attr("title") : "Download: " + page;
                    const label = elem.attr("title") ? elem.attr("title") + " [" + page + "]" : page;
                    if (cfg.analytics.downloads.hitType == "pageview") {
                      sendGAPageview({
                        url: loc,
                        title,
                        callback: newWindow ? null : () => {
                          clearTimeout(timer);
                          window.location.href = url.href;
                        }
                      });
                    } else if (cfg.analytics.downloads.hitType == "event") {
                      sendGAEvent({
                        eventCategory: "Download Links",
                        eventAction: "click",
                        eventLabel: label,
                        nonInteraction: cfg.analytics.downloads.nonInteraction,
                        hitCallback: newWindow ? null : () => {
                          clearTimeout(timer);
                          window.location.href = url.href;
                        }
                      });
                    }
                    return newWindow;
                  });
                }
              }
            });
          }
        };
        setup(jQuery("a[href]"));
        mutation.addHandler("addNode", "a[href]", setup);
      }
      if (cfg.analytics.errors.enabled) {
        log("Setting JavaScript errors tracking");
        const sendJSError = (errStr) => {
          const errHash = util.hash(errStr);
          if (vars.analytics.errorHashes.indexOf(errHash) == -1 && vars.analytics.errorHashes.length < cfg.analytics.errors.maxErrors) {
            vars.analytics.errorHashes.push(errHash);
            sendGAEvent({
              eventCategory: "JavaScript Errors",
              eventAction: "error",
              eventLabel: errStr,
              nonInteraction: true
            });
          }
        };
        window.addEventListener("error", (e) => {
          const errStr = `${e.message} ${e.error ? `[${e.error.toString()}] ` : " "}${e.filename}:${e.lineno}:${e.colno}`;
          sendJSError(errStr);
        });
        util.addErrorHandler((message, source, lineno, colno, error2) => {
          const errStr = `${message} ${error2 ? `[${error2.toString()}] ` : " "}${source}:${lineno}:${colno}`;
          sendJSError(errStr);
        });
      }
      if (cfg.analytics.scrollDepth.enabled) {
        log("Setting up scroll depth tracking");
        const calcScrollDepth = () => {
          if (vars.analytics.scrollDepthMax < 100) {
            const scrollDepthRatio = (vars.window.scrollTop() + vars.window.height()) / vars.document.height();
            vars.analytics.scrollDepthMax = Math.floor(scrollDepthRatio * 10) * 10;
          }
        };
        window.addEventListener("scroll", calcScrollDepth, { passive: true });
        vars.window.on("beforeunload", () => {
          calcScrollDepth();
          sendGAEvent({
            eventCategory: "Scroll Depth",
            eventAction: "Scroll Depth (%)",
            eventValue: vars.analytics.scrollDepthMax,
            nonInteraction: true
          });
        });
      }
      if (cfg.analytics.video.enabled) {
        log("Setting video tracking");
        window.addEventListener("message", vimeoReceiveMessage, false);
        jQuery('iframe[src*="youtube.com/embed/"], iframe[src*="player.vimeo.com/video/"]').each((idx, elem) => {
          initVideoPlayerAPI(jQuery(elem));
        });
        mutation.addHandler("addNode", 'iframe[src*="youtube.com/embed/"], iframe[src*="player.vimeo.com/video/"]', (e) => {
          initVideoPlayerAPI(jQuery(e));
        });
      }
      if (cfg.analytics.userActive.enabled) {
        log("Setting active time tracking");
        initUserActive();
        vars.window.on("beforeunload", () => {
          const userActiveRatio = vars.analytics.userActive.activeTime / (vars.analytics.userActive.activeTime + vars.analytics.userActive.inactiveTime);
          sendGAEvent({
            eventCategory: "User Active Time",
            eventAction: "Active Time (%)",
            eventValue: Math.floor(userActiveRatio * 10) * 10,
            nonInteraction: true
          });
          sendGAEvent({
            eventCategory: "User Active Time",
            eventAction: "Active Time (ms)",
            eventValue: parseInt(vars.analytics.userActive.activeTime),
            nonInteraction: true
          });
          sendGAEvent({
            eventCategory: "User Active Time",
            eventAction: "Inactive Time (ms)",
            eventValue: parseInt(vars.analytics.userActive.inactiveTime),
            nonInteraction: true
          });
        });
      }
      if (cfg.analytics.rageClicks.enabled) {
        log("Setting rage clicks tracking");
        jQuery("body").on("click", (e) => {
          vars.analytics.clickEvents.push({
            event: e,
            time: new Date().getTime() / 1000
          });
          if (vars.analytics.clickEvents.length >= cfg.analytics.rageClicks.minClicks) {
            const totalClicks = vars.analytics.clickEvents.length;
            const lastClick = totalClicks - 1;
            const timeDiff = vars.analytics.clickEvents[lastClick].time - vars.analytics.clickEvents[0].time;
            if (timeDiff <= cfg.analytics.rageClicks.maxTime) {
              let minX = vars.analytics.clickEvents[0].event.clientX;
              let maxX = vars.analytics.clickEvents[0].event.clientX;
              let minY = vars.analytics.clickEvents[0].event.clientY;
              let maxY = vars.analytics.clickEvents[0].event.clientY;
              for (let i = 1;i <= lastClick; i++) {
                const x = vars.analytics.clickEvents[i].event.clientX;
                const y = vars.analytics.clickEvents[i].event.clientY;
                if (x < minX)
                  minX = x;
                if (x > maxX)
                  maxX = x;
                if (y < minY)
                  minY = y;
                if (y > maxY)
                  maxY = y;
              }
              if (maxX - minX <= cfg.analytics.rageClicks.maxDistance && maxY - minY <= cfg.analytics.rageClicks.maxDistance) {
                minX = Math.floor(minX / 50) * 50;
                maxX = Math.ceil(maxX / 50) * 50;
                minY = Math.floor(minY / 50) * 50;
                maxY = Math.ceil(maxY / 50) * 50;
                sendGAEvent({
                  eventCategory: "Rage Click",
                  eventAction: "click",
                  eventLabel: [minX, minY, maxX, maxY].join(","),
                  nonInteraction: true
                });
              }
            }
            vars.analytics.clickEvents.splice(0, totalClicks);
          }
        });
      }
      if (cfg.analytics.performance.enabled) {
        log("Setting performance tracking");
        vars.window.on("beforeunload", () => {
          const perfArr = window.performance.getEntriesByType("navigation");
          if (perfArr.length > 0) {
            const perf = perfArr[0];
            sendGAEvent({
              eventCategory: "Performance",
              eventAction: "Ready Time (ms)",
              eventValue: Math.floor(perf.domInteractive),
              nonInteraction: true
            });
            sendGAEvent({
              eventCategory: "Performance",
              eventAction: "Load Time (ms)",
              eventValue: Math.floor(perf.duration),
              nonInteraction: true
            });
          }
        });
      }
      vars.analytics.status = "ready";
      vars.analytics.queue.forEach((item) => {
        if (item.type == "pageview")
          sendGAPageview(item.info);
        else if (item.type == "event")
          sendGAEvent(item.info);
      });
    };
    const initVideoPlayerAPI = (elem) => {
      const src = elem.attr("src");
      if (typeof src != "undefined") {
        let playerId = elem.attr("id");
        if (src.indexOf("youtube.com/embed/") != -1) {
          if (!vars.analytics.youTubeIframeAPIReady) {
            const ytScript = document.createElement("script");
            ytScript.async = true;
            ytScript.src = "https://www.youtube.com/iframe_api";
            ytScript.onload = () => {
              vars.analytics.youTubeIframeAPIReady = true;
            };
            document.head.appendChild(ytScript);
          }
          if (!playerId) {
            playerId = "youtubePlayer" + Object.keys(vars.analytics.youtubePlayers).length;
            elem.attr("id", playerId);
          }
          if (src.indexOf("enablejsapi=1") == -1) {
            elem.attr("src", src + (src.indexOf("?") == -1 ? "?" : "&") + "enablejsapi=1&version=3");
          }
          if (!(playerId in vars.analytics.youtubePlayers)) {
            vars.analytics.youtubePlayers[playerId] = {};
            onYouTubeIframeAPIReady();
          }
        }
        if (src.indexOf("player.vimeo.com/video/") != -1) {
          if (!playerId) {
            playerId = "vimeoPlayer" + Object.keys(vars.analytics.vimeoPlayers).length;
            elem.attr("id", playerId);
          }
          if (src.indexOf("api=1") == -1) {
            elem.attr("src", src + (src.indexOf("?") == -1 ? "?" : "&") + "api=1&player_id=" + playerId);
          }
          if (!(playerId in vars.analytics.vimeoPlayers)) {
            vars.analytics.vimeoPlayers[playerId] = {};
          }
        }
      }
    };
    const onYouTubeIframeAPIReady = (count) => {
      if (!count)
        count = 0;
      if (vars.analytics.youTubeIframeAPIReady && typeof YT !== "undefined" && YT && "Player" in YT) {
        Object.keys(vars.analytics.youtubePlayers).forEach((playerId) => {
          if (!("playerObj" in vars.analytics.youtubePlayers[playerId])) {
            vars.analytics.youtubePlayers[playerId].playerObj = new YT.Player(playerId, {
              events: {
                onReady: (e) => {
                  youtubePlayerReady(e, playerId);
                },
                onStateChange: (e) => {
                  youtubePlayerStateChange(e, playerId);
                }
              }
            });
          }
        });
      } else {
        count++;
        if (count < 600)
          window.setTimeout(() => {
            onYouTubeIframeAPIReady(count);
          }, 100);
        else
          error("YouTube API not available");
      }
    };
    const youtubePlayerReady = (e, playerId) => {
      if (jQuery("#" + playerId).length) {
        if (typeof vars.analytics.youtubePlayers[playerId].playerObj.getPlayerState != "function") {
        } else {
          if (!("progress" in vars.analytics.youtubePlayers[playerId])) {
            vars.analytics.youtubePlayers[playerId].progress = 0;
            vars.analytics.youtubePlayers[playerId].start = false;
            vars.analytics.youtubePlayers[playerId].complete = false;
            const videoData = vars.analytics.youtubePlayers[playerId].playerObj.getVideoData();
            vars.analytics.youtubePlayers[playerId].title = videoData.title;
            vars.analytics.youtubePlayers[playerId].duration = vars.analytics.youtubePlayers[playerId].playerObj.getDuration();
            if (!vars.analytics.youtubePlayers[playerId].start)
              youtubePlayerStateChange(e, playerId);
          }
        }
      } else {
        delete vars.analytics.youtubePlayers[playerId];
      }
    };
    const youtubePlayerStateChange = (e, playerId) => {
      if (jQuery("#" + playerId).length) {
        let label;
        if (vars.analytics.youtubePlayers[playerId].playerObj.getPlayerState() === 0 && !vars.analytics.youtubePlayers[playerId].complete) {
          label = "Complete";
          vars.analytics.youtubePlayers[playerId].complete = true;
        }
        if (vars.analytics.youtubePlayers[playerId].playerObj.getPlayerState() == 1) {
          vars.analytics.youtubePlayers[playerId].timer = window.setTimeout(() => {
            youtubePlayerStateChange(e, playerId);
          }, 1000);
          if (!vars.analytics.youtubePlayers[playerId].start) {
            label = "Start";
            vars.analytics.youtubePlayers[playerId].start = true;
          } else {
            const currentTime = vars.analytics.youtubePlayers[playerId].playerObj.getCurrentTime();
            if (Math.ceil(Math.ceil(currentTime / vars.analytics.youtubePlayers[playerId].duration * 100) / 10) - 1 > vars.analytics.youtubePlayers[playerId].progress) {
              vars.analytics.youtubePlayers[playerId].progress = Math.ceil(Math.ceil(currentTime / vars.analytics.youtubePlayers[playerId].duration * 100) / 10) - 1;
              if (vars.analytics.youtubePlayers[playerId].progress != 10) {
                label = vars.analytics.youtubePlayers[playerId].progress * 10 + "%";
              } else {
                window.clearTimeout(vars.analytics.youtubePlayers[playerId].timer);
              }
            }
          }
        }
        if (vars.analytics.youtubePlayers[playerId].playerObj.getPlayerState() == 3) {
          vars.analytics.youtubePlayers[playerId].timer = window.setTimeout(() => {
            youtubePlayerStateChange(e, playerId);
          }, 1000);
        }
        if (label) {
          videoTrackingEvent(playerId, label, vars.analytics.youtubePlayers[playerId].title, vars.analytics.youtubePlayers[playerId].progress * 10);
        }
      } else {
        delete vars.analytics.youtubePlayers[playerId];
      }
    };
    const vimeoReceiveMessage = (e) => {
      if (/^https?:\/\/player.vimeo.com/.test(e.origin)) {
        const data = JSON.parse(e.data);
        const player = vars.analytics.vimeoPlayers[data.player_id];
        let label;
        switch (data.event) {
          case "ready":
            player.progress = 0;
            player.start = false;
            player.complete = false;
            vimeoSendMessage(data.player_id, e.origin, "addEventListener", "play");
            vimeoSendMessage(data.player_id, e.origin, "addEventListener", "finish");
            vimeoSendMessage(data.player_id, e.origin, "addEventListener", "playProgress");
            break;
          case "play":
            if (!player.start) {
              label = "Start";
              player.start = true;
            }
            break;
          case "playProgress": {
            const playerProgress = Math.floor(data.data.percent * 10) * 10;
            if (playerProgress > player.progress) {
              player.progress = playerProgress;
              if (player.progress != 10) {
                label = player.progress * 10 + "%";
              }
            }
            break;
          }
          case "finish":
            if (!player.complete) {
              label = "Complete";
              player.complete = true;
            }
        }
        if (label) {
          videoTrackingEvent(data.player_id, label, "No title", player.progress * 10);
        }
      }
    };
    const vimeoSendMessage = (playerId, origin, action, value) => {
      const data = {
        method: action
      };
      if (value)
        data["value"] = value;
      const playerElem = document.getElementById(playerId);
      if (playerElem !== null)
        playerElem.contentWindow?.postMessage(JSON.stringify(data), origin);
    };
    const videoTrackingEvent = (playerId, label, title, value) => {
      sendGAEvent({
        eventCategory: "Video",
        eventAction: label,
        eventLabel: title + " (" + jQuery("#" + playerId).attr("src").split("?")[0] + ")",
        eventValue: value,
        nonInteraction: cfg.analytics.video.nonInteraction
      });
    };
    const initUserActive = () => {
      vars.analytics.userActive = {
        active: true,
        timer: false,
        throttle: false,
        lastChangeTime: new Date().getTime(),
        activeTime: 0,
        inactiveTime: 0
      };
      ["resize", "scroll", "orientationchange"].forEach((e) => {
        window.addEventListener(e, userActive, { passive: true });
      });
      [
        "keydown",
        "keyup",
        "keypress",
        "mousewheel",
        "wheel",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel"
      ].forEach((e) => {
        document.addEventListener(e, userActive, { passive: true });
      });
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible")
          userActive();
        else
          userInactive();
      });
      const timer = window.setInterval(() => {
        if (vars.analytics.userActive.activeTime + vars.analytics.userActive.inactiveTime >= cfg.analytics.userActive.maxTime)
          window.clearInterval(timer);
        else {
          if (vars.analytics.userActive.active) {
            vars.analytics.userActive.activeTime += new Date().getTime() - vars.analytics.userActive.lastChangeTime;
          } else {
            vars.analytics.userActive.inactiveTime += new Date().getTime() - vars.analytics.userActive.lastChangeTime;
          }
          vars.analytics.userActive.lastChangeTime = new Date().getTime();
        }
      }, cfg.analytics.userActive.refresh);
      userActive();
    };
    const userActive = () => {
      if (!vars.analytics.userActive.throttle) {
        vars.analytics.userActive.throttle = true;
        window.setTimeout(() => {
          vars.analytics.userActive.throttle = false;
        }, cfg.analytics.userActive.throttle);
        if (!vars.analytics.userActive.active) {
          vars.analytics.userActive.active = true;
          vars.analytics.userActive.inactiveTime += new Date().getTime() - vars.analytics.userActive.lastChangeTime;
          vars.analytics.userActive.lastChangeTime = new Date().getTime();
        }
        vars.analytics.userActive.active = true;
        window.clearTimeout(vars.analytics.userActive.timer);
        vars.analytics.userActive.timer = window.setTimeout(() => {
          userInactive();
        }, cfg.analytics.userActive.idleTime);
      }
    };
    const userInactive = () => {
      vars.analytics.userActive.active = false;
      window.clearTimeout(vars.analytics.userActive.timer);
      vars.analytics.userActive.activeTime += new Date().getTime() - vars.analytics.userActive.lastChangeTime;
      vars.analytics.userActive.lastChangeTime = new Date().getTime();
    };
    const initABTesting = () => {
      log("abTest params", cfg.analytics.abTest);
      vars.analytics.abTestGroup = util.cookie("abTestGroup");
      if (!vars.analytics.abTestGroup.test(new RegExp(`^${cfg.analytics.abTest.name}-[AB]$`))) {
        if (Math.random() < cfg.analytics.abTest.split)
          vars.analytics.abTestGroup = cfg.analytics.abTest.name + "-A";
        else
          vars.analytics.abTestGroup = cfg.analytics.abTest.name + "-B";
      }
      util.cookie("abTestGroup", vars.analytics.abTestGroup, { maxAge: cfg.analytics.abTest.cookieDays * 86400, path: "/" });
      vars.body.attr("abtestgroup", vars.abTestGroup);
      abTestDisplay(jQuery(cfg.analytics.abTest.displaySelector));
      mutation.addHandler("addNode", cfg.analytics.abTest.displaySelector, abTestDisplay);
    };
    const abTestDisplay = (elems) => {
      if (elems instanceof Node) {
        elems = [elems];
      } else if (elems instanceof jQuery) {
        elems = elems.toArray();
      }
      if (elems.length) {
        elems.forEach((elem) => {
          elem = jQuery(elem);
          let elemGroupMatch = false;
          if (elem.attr("data-abtest") === vars.abTestGroup)
            elemGroupMatch = true;
          if (elem.hasClass("abtest-" + vars.abTestGroup))
            elemGroupMatch = true;
          if (!elemGroupMatch) {
            if (cfg.analytics.abTest.removeNoMatch)
              elem.remove();
            else
              elem.css("display", "none");
          }
        });
      }
    };
    return Object.defineProperties({
      init,
      sendGAEvent,
      sendGAPageview
    }, {
      status: {
        get() {
          return vars.analytics.status;
        },
        set() {
          return;
        }
      }
    });
  })();

  // ../lyquix/js/lib/lyquix/detect.ts
  var ua = window.navigator.userAgent;
  var detect = (() => {
    const init = (customCfg) => {
      if (vars.detect?.init)
        return;
      vars.detect = {
        init: false,
        mobile: null,
        browser: null,
        os: null,
        urlParams: {}
      };
      cfg.detect = {
        enabled: true,
        mobile: true,
        browser: true,
        os: true,
        urlParams: true
      };
      if (customCfg)
        cfg.detect = jQuery.extend(true, cfg.detect, customCfg);
      if (cfg.detect.enabled) {
        log("Initializing detect");
        if (cfg.detect.mobile)
          detectMobile();
        if (cfg.detect.browser)
          detectBrowser();
        if (cfg.detect.os)
          detectOS();
        if (cfg.detect.urlParams)
          detectUrlParams();
      }
      vars.detect.init = true;
    };
    const getFirstMatch = (regex) => {
      const match = ua.match(regex);
      return match && match.length > 1 && match[1] || "";
    };
    const getSecondMatch = (regex) => {
      const match = ua.match(regex);
      return match && match.length > 1 && match[2] || "";
    };
    const detectMobile = () => {
      if (typeof MobileDetect == "function") {
        const md = new MobileDetect(window.navigator.userAgent);
        const r = {
          mobile: false,
          phone: false,
          tablet: false
        };
        for (const key of Object.keys(r)) {
          r[key] = md[key]() !== null;
          if (r[key])
            vars.body.addClass(key);
        }
        log("Detect mobile", r);
        vars.detect.mobile = r;
        return true;
      } else {
        log("MobileDetect library not loaded");
        return false;
      }
    };
    const detectBrowser = () => {
      let browser;
      if (/opera|opr/i.test(ua)) {
        browser = {
          name: "Opera",
          type: "opera",
          version: getFirstMatch(/version\/(\d+(\.\d+)?)/i) || getFirstMatch(/(?:opera|opr)[\s/](\d+(\.\d+)?)/i)
        };
      } else if (/msie|trident/i.test(ua)) {
        browser = {
          name: "Internet Explorer",
          type: "msie",
          version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
        };
      } else if (/chrome.+? edge/i.test(ua)) {
        browser = {
          name: "Microsft Edge",
          type: "msedge",
          version: getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
        };
      } else if (/chrome|crios|crmo/i.test(ua)) {
        browser = {
          name: "Google Chrome",
          type: "chrome",
          version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
        };
      } else if (/firefox/i.test(ua)) {
        browser = {
          name: "Firefox",
          type: "firefox",
          version: getFirstMatch(/(?:firefox)[ /](\d+(\.\d+)?)/i)
        };
      } else if (/safari/i.test(ua)) {
        browser = {
          name: "Safari",
          type: "safari",
          version: getFirstMatch(/version\/(\d+(\.\d+)?)/i) || getFirstMatch(/safari\/(\d+(\.\d+)?)/i)
        };
      } else {
        browser = {
          name: getFirstMatch(/^(.*)\/(.*) /),
          version: getSecondMatch(/^(.*)\/(.*) /)
        };
        browser.type = browser.name.toLowerCase().replace(/\s/g, "");
      }
      if (browser.type && browser.version) {
        vars.body.addClass(browser.type);
        vars.body.addClass(browser.type + "-" + browser.version.split(".")[0]);
        vars.body.addClass(browser.type + "-" + browser.version.replace(/\./g, "-"));
      }
      log("Detect browser", browser);
      vars.detect.browser = browser;
      return true;
    };
    const detectOS = () => {
      let os;
      if (/(ipod|iphone|ipad)/i.test(ua)) {
        os = {
          name: "iOS",
          type: "ios",
          version: getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i).replace(/[_\s]/g, ".")
        };
      } else if (/windows phone/i.test(ua)) {
        os = {
          name: "Windows Phone",
          type: "windowsphone",
          version: getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i)
        };
      } else if (!/like android/i.test(ua) && /android/i.test(ua)) {
        os = {
          name: "Android",
          type: "android",
          version: getFirstMatch(/android[ /-](\d+(\.\d+)*)/i)
        };
      } else if (/windows nt/i.test(ua)) {
        os = {
          name: "Windows",
          type: "windows",
          version: getFirstMatch(/windows nt (\d+(\.\d+)*)/i)
        };
      } else if (/mac os x/i.test(ua)) {
        os = {
          name: "Mac OS X",
          type: "macosx",
          version: getFirstMatch(/mac os x (\d+([_\s]\d+)*)/i).replace(/[_\s]/g, ".")
        };
      } else if (/ubuntu/i.test(ua)) {
        os = {
          name: "Ubuntu",
          type: "ubuntu",
          version: getFirstMatch(/ubuntu\/(\d+(\.\d+)*)/i)
        };
      } else if (/fedora/i.test(ua)) {
        os = {
          name: "Fedora",
          type: "fedora",
          version: getFirstMatch(/fedora\/(\d+(\.\d+)*)/i)
        };
      } else if (/CrOS/.test(ua)) {
        os = {
          name: "Chrome OS",
          type: "chromeos",
          version: getSecondMatch(/cros (.+) (\d+(\.\d+)*)/i)
        };
      }
      if (os.type && os.version) {
        vars.body.addClass(os.type);
        vars.body.addClass(os.type + "-" + os.version.split(".")[0]);
        vars.body.addClass(os.type + "-" + os.version.replace(/\./g, "-"));
      }
      log("Detect O/S", os);
      vars.detect.os = os;
      return true;
    };
    const detectUrlParams = () => {
      vars.detect.urlParams = util.parseUrlParams(window.location.href);
      log("Detect URL params", vars.detect.urlParams);
      return true;
    };
    return Object.defineProperties({
      init
    }, {
      mobile: {
        get() {
          return vars.detect.mobile;
        },
        set() {
          return;
        }
      },
      browser: {
        get() {
          return vars.detect.browser;
        },
        set() {
          return;
        }
      },
      os: {
        get() {
          return vars.detect.os;
        },
        set() {
          return;
        }
      },
      urlParams: {
        get() {
          return vars.detect.urlParams;
        },
        set() {
          return;
        }
      }
    });
  })();

  // ../lyquix/js/lib/lyquix/geolocate.ts
  var geolocate = (() => {
    const init = (customCfg) => {
      if (vars.geolocate?.init)
        return;
      vars.geolocate = {
        location: {
          source: null,
          city: null,
          subdivision: null,
          country: null,
          continent: null,
          time_zone: null,
          lat: null,
          lon: null,
          radius: null,
          ip: null
        },
        regions: [],
        cookies: {
          ip: null,
          gps: null
        },
        status: {
          ip: null,
          gps: null
        },
        ready: false
      };
      cfg.geolocate = {
        enabled: true,
        gps: false,
        useCookies: true,
        cookieExpirationIP: 900,
        cookieExpirationGPS: 900,
        handleNoRegionMatch: true,
        removeNoRegionMatch: true,
        regionDisplaySelector: '[data-region-display], [class*="region-name-"]',
        regions: []
      };
      if (customCfg)
        cfg.geolocate = jQuery.extend(true, cfg.geolocate, customCfg);
      if (cfg.geolocate.enabled) {
        log("Initializing geolocate");
        geoLocate();
        mutation.addHandler("addNode", cfg.geolocate.regionDisplaySelector, regionDisplay);
        vars.document.on("geolocateready", regionDisplay);
      }
      vars.geolocate.init = true;
    };
    const geoLocate = () => {
      const selectedRegion = util.cookie("selectedRegion");
      if (selectedRegion) {
        log("Region override from selectedRegion cookie:", selectedRegion);
        vars.geolocate.regions = [selectedRegion];
        vars.geolocate.status.ip = "ready";
        vars.geolocate.status.gps = "n/a";
        bodyGeoData();
        regionDisplay();
        return;
      }
      if (cfg.geolocate.useCookies) {
        log("Attempting to geolocate from cookies");
        vars.geolocate.cookies.ip = util.cookie("lqx.geolocate.cookies.ip");
        if (vars.geolocate.cookies.ip !== null)
          vars.geolocate.cookies.ip = JSON.parse(vars.geolocate.cookies.ip);
        if (vars.geolocate.cookies.ip !== null) {
          vars.geolocate.location = Object.assign({}, vars.geolocate.cookies.ip);
          vars.geolocate.location.source = "ip2geo-cookie";
          vars.geolocate.status.ip = "cookie";
        } else
          getIP();
        vars.geolocate.cookies.gps = util.cookie("lqx.geolocate.cookies.gps");
        if (vars.geolocate.cookies.gps !== null)
          vars.geolocate.cookies.gps = JSON.parse(vars.geolocate.cookies.gps);
        if (cfg.geolocate.gps && "geolocation" in window.navigator) {
          if (vars.geolocate.cookies.gps !== null) {
            vars.geolocate.location = Object.assign({}, vars.geolocate.cookies.gps);
            vars.geolocate.location.source = "gps-cookie";
            vars.geolocate.status.gps = "cookie";
          } else
            getGPS();
        } else
          vars.geolocate.status.gps = "n/a";
        bodyGeoData();
      } else {
        getIP();
        getGPS();
      }
    };
    const getIP = () => {
      log("Attempting IP geolocation");
      vars.geolocate.status.ip = "wait";
      jQuery.ajax({
        async: true,
        cache: false,
        dataType: "json",
        url: cfg.siteURL + "/wp-json/lyquix/v3/ip2geo",
        success: (data) => {
          if (vars.geolocate.location.source !== "gps" && vars.geolocate.location.source !== "gps-cookie") {
            vars.geolocate.location = data;
            vars.geolocate.location.source = "ip2geo";
          }
          vars.geolocate.status.ip = "ready";
          console.log("succesful ipgeo");
          log("IP geolocation result", vars.geolocate.location);
          if (cfg.geolocate.useCookies)
            util.cookie("lqx.geolocate.locationIP", JSON.stringify(vars.geolocate.location), { maxAge: cfg.geolocate.cookieExpirationIP, path: "/", secure: true });
          bodyGeoData();
        },
        error: (xhr, ready2, error2) => {
          error2("Geolocate error " + ready2 + " " + error2);
        }
      });
    };
    const getGPS = () => {
      if (cfg.geolocate.gps && "geolocation" in window.navigator) {
        log("Attempting GPS geolocation");
        vars.geolocate.status.gps = "wait";
        window.navigator.geolocation.getCurrentPosition((position) => {
          vars.geolocate.location.lat = position.coords.latitude;
          vars.geolocate.location.lon = position.coords.longitude;
          vars.geolocate.location.radius = position.coords.accuracy / 1000;
          vars.geolocate.location.source = "gps";
          vars.geolocate.status.gps = "ready";
          log("GPS geolocation result", vars.geolocate.location);
          if (cfg.geolocate.useCookies)
            util.cookie("lqx.geolocate.locationGPS", JSON.stringify(vars.geolocate.location), { maxAge: cfg.geolocate.cookieExpirationGPS, path: "/", secure: true });
          bodyGeoData();
        });
      } else
        vars.geolocate.status.gps = "n/a";
    };
    const bodyGeoData = () => {
      if (["cookie", "ready"].includes(vars.geolocate.status.ip) && ["cookie", "ready", "n/a"].includes(vars.geolocate.status.gps)) {
        for (const key in vars.geolocate.location) {
          if (key == "time_zone") {
            vars.body.attr("time-zone", vars.geolocate.location.time_zone);
          } else if (["source", "ip"].indexOf(key) == -1) {
            vars.body.attr(key, vars.geolocate.location[key]);
          }
        }
        if (!vars.geolocate.regions.length)
          matchRegions();
        vars.body.attr("regions", vars.geolocate.regions.join(","));
        log("geolocateready event");
        vars.geolocate.ready = true;
        vars.document.trigger("geolocateready");
      }
    };
    const ready = (callback) => {
      if (vars.geolocate.ready === true) {
        callback();
      } else {
        vars.document.on("geolocateready", callback);
      }
    };
    const inPolygon = (testLon, testLat, ring) => {
      if (ring.length < 3)
        return false;
      let j = ring.length - 1, oddNodes = false;
      for (let i = 0;i < ring.length; i++) {
        const iLon = ring[i][0], iLat = ring[i][1];
        const jLon = ring[j][0], jLat = ring[j][1];
        if (iLat < testLat && jLat >= testLat || jLat < testLat && iLat >= testLat) {
          if (iLon + (testLat - iLat) / (jLat - iLat) * (jLon - iLon) < testLon) {
            oddNodes = !oddNodes;
          }
        }
        j = i;
      }
      return oddNodes;
    };
    const inPolygonCoords = (testLon, testLat, coords) => {
      if (!coords[0] || coords[0].length < 3)
        return false;
      if (!inPolygon(testLon, testLat, coords[0]))
        return false;
      for (let i = 1;i < coords.length; i++) {
        if (coords[i] && inPolygon(testLon, testLat, coords[i]))
          return false;
      }
      return true;
    };
    const pointInGeoJSON = (testLon, testLat, geojson) => {
      const type = geojson?.type;
      if (type === "FeatureCollection" && Array.isArray(geojson.features)) {
        for (const feature of geojson.features) {
          if (feature && pointInGeoJSON(testLon, testLat, feature))
            return true;
        }
        return false;
      }
      if (type === "Feature") {
        if (!geojson.geometry)
          return false;
        return pointInGeoJSON(testLon, testLat, geojson.geometry);
      }
      if (type === "Polygon" && Array.isArray(geojson.coordinates)) {
        return inPolygonCoords(testLon, testLat, geojson.coordinates);
      }
      if (type === "MultiPolygon" && Array.isArray(geojson.coordinates)) {
        for (const polyCoords of geojson.coordinates) {
          if (Array.isArray(polyCoords) && inPolygonCoords(testLon, testLat, polyCoords))
            return true;
        }
        return false;
      }
      return false;
    };
    const matchRegions = () => {
      const lat = vars.geolocate.location.lat;
      const lon = vars.geolocate.location.lon;
      cfg.geolocate.regions.forEach((region) => {
        if (!region.alias || !region.geojson)
          return;
        if (pointInGeoJSON(lon, lat, region.geojson) && !vars.geolocate.regions.includes(region.alias)) {
          vars.geolocate.regions.push(region.alias);
        }
      });
      vars.body.attr("regions", vars.geolocate.regions.join(","));
    };
    const regionDisplay = (elems) => {
      if (elems instanceof jQuery.Event)
        elems = undefined;
      if (elems == undefined) {
        elems = jQuery(cfg.geolocate.regionDisplaySelector);
      }
      if (elems instanceof Node) {
        elems = [elems];
      } else if (elems instanceof jQuery) {
        elems = elems.toArray();
      }
      if (elems.length) {
        elems.forEach((elem) => {
          elem = jQuery(elem);
          let elemOpts = {
            regions: [],
            action: "show",
            display: "block"
          };
          let elemRegionMatch = false;
          let elemAttribOpts = elem.attr("data-region-display");
          if (typeof elemAttribOpts != "undefined") {
            elemAttribOpts = JSON.parse(elemAttribOpts);
            if (typeof elemAttribOpts == "object") {
              elemOpts = elemAttribOpts;
              if (typeof elemOpts.regions == "string")
                elemOpts.regions = [elemOpts.regions];
              elemOpts.regions.forEach((region) => {
                if (vars.geolocate.regions.indexOf(region) != -1)
                  elemRegionMatch = true;
              });
            }
          }
          const elemClasses = elem.attr("class").split(/\s+/);
          elemClasses.forEach((elemClass) => {
            if (elemClass.indexOf("region-action-") == 0)
              elemOpts.action = elemClass.replace("region-action-", "");
            else if (elemClass.indexOf("region-display-") == 0)
              elemOpts.display = elemClass.replace("region-display-", "");
            else if (elemClass.indexOf("region-name-") == 0)
              elemOpts.regions.push(elemClass.replace("region-name-", ""));
          });
          elemOpts.regions.forEach((region) => {
            if (vars.geolocate.regions.indexOf(region) != -1)
              elemRegionMatch = true;
          });
          if (!("action" in elemOpts))
            elemOpts.action = "show";
          if (!("display" in elemOpts))
            elemOpts.display = "block";
          if (elemRegionMatch) {
            if (elemOpts.action == "show")
              elem.css("display", elemOpts.display);
            else if (elemOpts.action == "hide") {
              if (cfg.geolocate.removeNoRegionMatch)
                elem.remove();
              else
                elem.css("display", "none");
            }
          } else if (!elemRegionMatch && cfg.geolocate.handleNoRegionMatch) {
            if (elemOpts.action == "show") {
              if (cfg.geolocate.removeNoRegionMatch)
                elem.remove();
              elem.css("display", "none");
            } else if (elemOpts.action == "hide")
              elem.css("display", elemOpts.display);
          }
        });
      }
    };
    return Object.defineProperties({
      init,
      ready,
      regionDisplay
    }, {
      location: {
        get() {
          return vars.geolocate.location;
        },
        set() {
          return;
        }
      },
      regions: {
        get() {
          return vars.geolocate.regions;
        },
        set() {
          return;
        }
      },
      status: {
        get() {
          return vars.geolocate.status;
        },
        set() {
          return;
        }
      }
    });
  })();

  // ../lyquix/js/lib/lyquix/swipe.ts
  var swipe = (() => {
    const init = (customCfg) => {
      if (vars.swipe?.init)
        return;
      vars.swipe = {
        init: false,
        swipes: {}
      };
      cfg.swipe = {
        enabled: true,
        minX: 30,
        minY: 30,
        maxTime: 1500,
        disableScroll: true,
        detectV: true,
        detectH: true
      };
      if (customCfg)
        cfg.swipe = jQuery.extend(true, cfg.swipe, customCfg);
      if (cfg.swipe.enabled) {
        log("Initializing swipe");
      }
      vars.swipe.init = true;
    };
    const add = (sel, callback, customCfg) => {
      if (typeof sel !== "string" || typeof callback !== "function") {
        warn2("Invalid swipe selector or callback", sel);
        return;
      }
      log(`Setting up swipe detection for ${sel}`);
      const swipes = {
        sel,
        elems: []
      };
      jQuery(sel).each((index, elem) => {
        const theSwipe = {
          elem,
          callback,
          cfg: jQuery.extend({}, cfg),
          startX: 0,
          startY: 0,
          startTime: 0,
          endX: 0,
          endY: 0,
          endTime: 0,
          dir: "",
          touchstart: (e) => {
            const t = e.originalEvent.touches[0];
            theSwipe.startX = theSwipe.endX = t.clientX;
            theSwipe.startY = theSwipe.endY = t.clientY;
            const d = new Date;
            theSwipe.startTime = theSwipe.endTime = d.getTime() + d.getMilliseconds() / 1000;
            theSwipe.dir = "";
          },
          touchmove: (e) => {
            if (theSwipe.cfg.disableScroll)
              e.preventDefault();
            const t = e.touches[0];
            theSwipe.endX = t.clientX;
            theSwipe.endY = t.clientY;
            const d = new Date;
            theSwipe.endTime = d.getTime() + d.getMilliseconds() / 1000;
          },
          touchend: (e) => {
            const t = e.originalEvent.touches[0];
            theSwipe.endX = t.clientX;
            theSwipe.endY = t.clientY;
            const d = new Date;
            theSwipe.endTime = d.getTime() + d.getMilliseconds() / 1000;
            if (theSwipe.endTime > 0 && theSwipe.endTime - theSwipe.startTime <= theSwipe.cfg.maxTime) {
              if (theSwipe.cfg.detectH && Math.abs(theSwipe.endX - theSwipe.startX) > theSwipe.cfg.minX && theSwipe.endX > 0) {
                if (theSwipe.endX > theSwipe.startX)
                  theSwipe.dir += "r";
                else
                  theSwipe.dir += "l";
              }
              if (theSwipe.cfg.detectV && Math.abs(theSwipe.endY - theSwipe.startY) > theSwipe.cfg.minY && theSwipe.endY > 0) {
                if (theSwipe.endY > theSwipe.startY)
                  theSwipe.dir += "d";
                else
                  theSwipe.dir += "u";
              }
              if (theSwipe.dir != "") {
                log(`Detected swipe ${theSwipe.dir} for ${sel}(${index})`);
                callback({
                  sel,
                  index,
                  elem,
                  dir: theSwipe.dir
                });
              }
            }
          }
        };
        if (typeof customCfg == "object")
          theSwipe.cfg = jQuery.extend(true, theSwipe.cfg, customCfg);
        elem.addEventListener("touchstart", theSwipe.touchstart);
        elem.addEventListener("touchmove", theSwipe.touchmove, { passive: !theSwipe.cfg.disableScroll });
        elem.addEventListener("touchend", theSwipe.touchend);
        swipes.elems.push(theSwipe);
      });
      vars.swipe.swipes[sel] = swipes;
    };
    const update = (sel, callback, customCfg) => {
      if (typeof sel !== "string" || typeof callback !== "function") {
        warn2("Invalid swipe selector or callback", sel);
        return;
      }
      swipe.remove(sel);
      swipe.add(sel, callback, customCfg);
    };
    const remove = (sel) => {
      if (!(sel in vars.swipe.swipes)) {
        warn2(`Selector ${sel} doesn't have an active swiper event`);
        return;
      }
      vars.swipe.swipes[sel].elems.forEach((swipe2) => {
        swipe2.elem.removeEventListener("touchstart", swipe2.touchstart);
        swipe2.elem.removeEventListener("touchmove", swipe2.touchmove);
        swipe2.elem.removeEventListener("touchend", swipe2.touchend);
      });
      delete vars.swipe.swipes[sel];
    };
    return {
      init,
      add,
      update,
      remove
    };
  })();

  // ../lyquix/js/lib/lyquix/lyqbox.ts
  var lyqbox = (() => {
    const init = (customCfg) => {
      if (vars.lyqbox?.init)
        return;
      vars.lyqbox = {
        init: false,
        lightboxes: {}
      };
      cfg.lyqbox = {
        enabled: true,
        selector: "[data-lyqbox]",
        analytics: {
          enabled: true,
          nonInteraction: true
        },
        template: `
\t\t\t\t<dialog class="lyqbox" aria-labeledby aria-describedby aria-modal="true" aria-hidden="true">
\t\t\t\t\t<section class="wrapper">
\t\t\t\t\t\t<div class="content"></div>
\t\t\t\t\t\t<div class="info">
\t\t\t\t\t\t\t<h2 class="title"></h2>
\t\t\t\t\t\t\t<div class="caption"></div>
\t\t\t\t\t\t\t<div class="credit"></div>
\t\t\t\t\t\t</div>
\t\t\t\t\t</section>
\t\t\t\t\t<section class="wrapper">
\t\t\t\t\t\t<div class="content"></div>
\t\t\t\t\t\t<div class="info">
\t\t\t\t\t\t\t<h2 class="title"></h2>
\t\t\t\t\t\t\t<div class="caption"></div>
\t\t\t\t\t\t\t<div class="credit"></div>
\t\t\t\t\t\t</div>
\t\t\t\t\t</section>
\t\t\t\t\t<button class="close" autofocus></button>
\t\t\t\t\t<div class="prev"></div>
\t\t\t\t\t<div class="next"></div>
\t\t\t\t\t<div class="counter">
\t\t\t\t\t\t<span class="current"></span> / <span class="total"></span>
\t\t\t\t\t</div>
\t\t\t\t\t<ul class="navigation">
\t\t\t\t\t</ul>
\t\t\t\t</dialog>`
      };
      if (customCfg)
        cfg.lyqbox = jQuery.extend(true, cfg.lyqbox, customCfg);
      if (cfg.lyqbox.enabled) {
        log("Initializing `lyqbox`");
        cfg.lyqbox.analytics.enabled = cfg.analytics.enabled ? cfg.lyqbox.analytics.enabled : false;
        if (cfg.lyqbox.analytics.enabled)
          log("Setting LyqBox tracking");
        vars.document.ready(() => {
          setup(jQuery(cfg.lyqbox.selector));
          mutation.addHandler("addNode", cfg.lyqbox.selector, setup);
          showHash();
        });
      }
      vars.lyqbox.init = true;
    };
    const setup = (elems) => {
      if (elems.length) {
        log("Setting up " + elems.length + " lightboxes", elems);
        elems.each((idx, slide) => {
          slide = jQuery(slide);
          let mode = "single";
          let opts = slide.attr("data-lyqbox");
          if (opts)
            opts = JSON.parse(opts);
          else {
            warn2("Invalid JSON in data-lyquix attribute", slide);
            return;
          }
          if (opts.encoding === "base64" && opts.html) {
            opts.html = atob(opts.html);
            delete opts.encoding;
          }
          if (!("name" in opts) || !opts.name) {
            warn2("`name` is a required option in data-lyquix", slide);
            return;
          }
          opts.name = util.slugify(opts.name);
          if (!(opts.name in vars.lyqbox.lightboxes)) {
            vars.lyqbox.lightboxes[opts.name] = {
              name: opts.name,
              current: 0,
              elem: null,
              mode,
              open: false,
              loading: false,
              slides: [],
              template: null,
              useHash: null
            };
          } else {
            let slugFound = false;
            if (opts.slug) {
              slugFound = vars.lyqbox.lightboxes[opts.name].slides.filter((e) => e["slug"] == opts.slug);
              if (slugFound == false) {
                mode = "gallery";
                vars.lyqbox.lightboxes[opts.name].mode = mode;
              }
            } else {
              mode = "gallery";
              vars.lyqbox.lightboxes[opts.name].mode = mode;
            }
          }
          if (!("type" in opts) || !opts.type) {
            warn2("`type` is a required option in data-lyquix", slide);
            return;
          }
          if (!["image", "video", "html", "url", "dom"].includes(opts.type)) {
            warn2("Invalid `type` in data-lyquix", slide, opts.type);
            return;
          }
          if (vars.lyqbox.lightboxes[opts.name].useHash === null) {
            if ("useHash" in opts)
              vars.lyqbox.lightboxes[opts.name].useHash = !!opts.useHash;
            else
              vars.lyqbox.lightboxes[opts.name].useHash = true;
            delete opts.useHash;
          }
          const index = vars.lyqbox.lightboxes[opts.name].slides.length;
          if (!("slug" in opts) || !opts.slug) {
            if (vars.lyqbox.lightboxes[opts.name].useHash) {
              warn2("`slug` is a required option in data-lyquix when using hash", slide);
              return;
            }
            opts.slug = "slide-" + index;
            log("No `slug` provided, generating one", slide);
          }
          switch (opts.type) {
            case "image":
            case "video":
            case "url":
              if (!("url" in opts) || !opts.url) {
                warn2("`url` is a required option in data-lyquix for type " + opts.type, slide);
                return;
              }
              break;
            case "html":
              if (!("html" in opts) || !opts.html) {
                warn2("`html` is a required option in data-lyquix for type html", slide);
                return;
              }
              break;
            case "dom":
              if (!("selector" in opts) || !opts.selector) {
                warn2("`selector` is a required option in data-lyquix for type dom", slide);
                return;
              }
              if (jQuery(opts.selector).length == 0) {
                warn2("DOM element not found for selector " + opts.selector, slide);
                return;
              }
              opts.html = jQuery(opts.selector).get(0).outerHTML;
              jQuery(opts.selector).remove();
              break;
            default:
              break;
          }
          ["title", "caption", "credit", "class", "thumb", "teaser"].forEach((key) => {
            if (!(key in opts))
              opts[key] = "";
          });
          if (opts.type == "image" && (!("alt" in opts) || !opts.alt)) {
            if (opts.title) {
              log("No `alt` provided, using slide title", slide);
              opts.alt = opts.title;
            }
            warn2("No `alt` provided for image slide", slide);
          }
          if (vars.lyqbox.lightboxes[opts.name].template === null) {
            if ("template" in opts) {
              if (opts.template)
                vars.lyqbox.lightboxes[opts.name].template = opts.template;
              else
                vars.lyqbox.lightboxes[opts.name].template = cfg.lyqbox.template;
              delete opts.template;
            } else
              vars.lyqbox.lightboxes[opts.name].template = cfg.lyqbox.template;
          }
          opts.elem = slide;
          vars.lyqbox.lightboxes[opts.name].slides.push(opts);
          slide.on("click", (e) => {
            e.preventDefault();
            open(opts.name, index);
          });
        });
      }
    };
    const open = (name, index = 0) => {
      if (!(name in vars.lyqbox.lightboxes)) {
        warn2(`Lightbox ${name} not found`);
        return;
      }
      log(`Open lightbox ${name}`);
      const lightbox = vars.lyqbox.lightboxes[name];
      if (lightbox.elem === null) {
        const elem = jQuery(lightbox.template);
        const id = "id-" + util.hash(name);
        elem.attr("id", id);
        elem.attr("data-lyqbox-name", name);
        elem.find(".wrapper").first().addClass("active");
        elem.find(".close").on("click", () => {
          elem.get(0).close();
        });
        elem.on("close", () => {
          close(name);
        });
        if (lightbox.mode == "gallery") {
          elem.find(".prev").on("click", () => {
            prev(name);
          });
          elem.find(".next").on("click", () => {
            next(name);
          });
          vars.document.on("keyup", (e) => {
            switch (e.key) {
              case "ArrowLeft":
              case "Left":
                prev(name);
                break;
              case "ArrowRight":
              case "Right":
                next(name);
                break;
            }
          });
          swipe.add(`#${id} .content`, (swp) => {
            if (swp.dir.indexOf("l") != -1)
              next(name);
            if (swp.dir.indexOf("r") != -1)
              prev(name);
          }, null);
          Object.keys(lightbox.slides).forEach((i) => {
            const slide = lightbox.slides[i];
            const thumbElem = `<li data-lyqbox-index="${i}">` + slide.thumb ? `<img src="${slide.thumb}" alt="Thumbnail for slide ${slide.title ? slide.title : i}">` : "" + slide.teaser ? `<span>${slide.teaser}</span>` : "" + "</li>";
            jQuery(thumbElem).appendTo(elem.find(".navigation")).on("click", () => {
              load(id, i);
            });
          });
        } else {
          elem.find(".wrapper:not(.active), .prev, .next, .counter, .navigation").remove();
        }
        elem.appendTo(vars.body);
        lightbox.elem = elem;
      }
      lightbox.elem.get(0).showModal();
      lightbox.elem.attr("aria-hidden", "false");
      lightbox.open = true;
      load(name, index);
    };
    const load = (name, index) => {
      if (!(name in vars.lyqbox.lightboxes)) {
        warn2(`Lightbox ${name} not found`);
        return;
      }
      const lightbox = vars.lyqbox.lightboxes[name];
      if (index < 0 || index >= lightbox.slides.length) {
        warn2(`Invalid slide index ${index} for lightbox ${name}`);
        return;
      }
      const slide = lightbox.slides[index];
      log(`Open slide ${index} on lightbox ${name}`);
      let content;
      switch (slide.type) {
        case "image":
          content = `<img src="${slide.url}" alt="${slide.alt}" />`;
          break;
        case "video": {
          const video = util.getVideoUrls(slide.url);
          content = `<iframe src="${video.url || slide.url}" class="video"></iframe>`;
          break;
        }
        case "url":
          content = `<iframe src="${slide.url}"></iframe>`;
          break;
        case "html":
        case "dom":
          try {
            content = decodeURI(slide.html);
          } catch (e) {
            content = slide.html;
          }
          break;
        default:
          break;
      }
      content = jQuery(content);
      if (["image", "video", "url"].includes(slide.type)) {
        lightbox.loading = true;
        lightbox.elem.addClass("loading");
        content.on("load", () => {
          lightbox.loading = false;
          lightbox.elem.removeClass("loading");
        });
      }
      let wrapper;
      if (lightbox.mode == "gallery") {
        wrapper = lightbox.elem.find(".wrapper").not(".active");
        lightbox.elem.find(".wrapper.active").removeClass("active").find(".content iframe.video").remove();
      } else
        wrapper = lightbox.elem.find(".wrapper");
      wrapper.addClass("active").find(".content").empty().append(content);
      lightbox.current = index;
      wrapper.find(".info .title").html(slide.title).attr("id", `lightbox-${lightbox.name}-slide-${index}-title`);
      lightbox.elem.attr("aria-labeledby", `lightbox-${lightbox.name}-slide-${index}-title`);
      wrapper.find(".info .caption").html(slide.caption).attr("id", `lightbox-${lightbox.name}-slide-${index}-description`);
      lightbox.elem.attr("aria-describedby", `lightbox-${lightbox.name}-slide-${index}-description`);
      wrapper.find(".info .credit").html(slide.credit);
      if (lightbox.mode == "gallery") {
        lightbox.elem.find(".counter .current").text(index + 1);
        lightbox.elem.find(".counter .total").text(lightbox.slides.length);
        lightbox.elem.find(".navigation").children().removeClass("active").eq(index).addClass("active");
      }
      if (lightbox.useHash) {
        let hash = "#" + encodeURIComponent(name);
        if (lightbox.mode == "gallery")
          hash += "/" + index + "-" + encodeURIComponent(slide.slug);
        window.history.replaceState(null, "", hash);
      }
      if (cfg.lyqbox.analytics.enabled && cfg.lyqbox.analytics.onOpen) {
        analytics.sendGAEvent({
          eventCategory: "Lightbox",
          eventAction: "Load",
          eventLabel: `${name}|${index}|${slide.slug}`,
          nonInteraction: cfg.lyqbox.analytics.nonInteraction
        });
      }
    };
    const next = (name) => {
      if (!(name in vars.lyqbox.lightboxes)) {
        warn2(`Lightbox ${name} not found`);
        return;
      }
      const lightbox = vars.lyqbox.lightboxes[name];
      if (lightbox.mode != "gallery" || !lightbox.open || lightbox.loading)
        return;
      log(`Next slide on lightbox ${name}`);
      if (lightbox.current == lightbox.slides.length - 1)
        load(name, 0);
      else
        load(name, lightbox.current + 1);
    };
    const prev = (name) => {
      if (!(name in vars.lyqbox.lightboxes)) {
        warn2(`Lightbox ${name} not found`);
        return;
      }
      const lightbox = vars.lyqbox.lightboxes[name];
      if (lightbox.mode != "gallery" || !lightbox.open || lightbox.loading)
        return;
      log(`Previous slide on lightbox ${name}`);
      if (lightbox.current == 0)
        load(name, lightbox.slides.length - 1);
      else
        load(name, lightbox.current - 1);
    };
    const close = (name) => {
      if (!(name in vars.lyqbox.lightboxes)) {
        warn2(`Lightbox ${name} not found`);
        return;
      }
      const lightbox = vars.lyqbox.lightboxes[name];
      lightbox.open = false;
      lightbox.elem.attr("aria-hidden", "true");
      lightbox.elem.find(".content").empty();
      lightbox.elem.find(".navigation").children().removeClass("active");
      if (lightbox.useHash)
        window.history.replaceState(null, "", "#");
      log(`Close lightbox ${name}`);
    };
    const showHash = () => {
      const hash = window.location.hash.substr(1);
      if (hash) {
        const hashParts = hash.split("/");
        if (hashParts.length == 1) {
          open(decodeURIComponent(hash));
        } else if (hashParts.length == 2) {
          const slideParts = hashParts[1].split("-");
          open(decodeURIComponent(hashParts[0]), parseInt(slideParts[0]));
        }
      }
    };
    return {
      init,
      open,
      prev,
      next,
      close
    };
  })();

  // ../lyquix/js/lib/lyquix/store.ts
  var store = (() => {
    const init = (customCfg) => {
      if (vars.store?.init)
        return;
      vars.store = {
        init: false,
        tracked: []
      };
      cfg.store = {
        enabled: true,
        itemName: "lqxStore",
        updateInterval: 15
      };
      if (customCfg)
        cfg.store = jQuery.extend(true, cfg.store, customCfg);
      if (cfg.store.enabled) {
        log("Initializing store");
        let lqxStore = window.localStorage.getItem(cfg.store.itemName);
        if (lqxStore === null)
          window.localStorage.setItem(cfg.store.itemName, "{}");
        else {
          try {
            lqxStore = JSON.parse(lqxStore);
          } catch (e) {
            warn2("Invalid JSON in localStorage, resetting store");
            lqxStore = {};
            window.localStorage.setItem(cfg.store.itemName, "{}");
          }
          Object.keys(lqxStore).forEach((objName) => {
            vars.store.tracked[objName] = {};
            Object.keys(lqxStore[objName]).forEach((prop) => {
              vars.store.tracked[objName][prop] = lqxStore[objName][prop];
            });
          });
        }
        window.addEventListener("beforeunload", store.update);
        window.setInterval(store.update, cfg.store.updateInterval * 1000);
      }
      vars.store.init = true;
    };
    const get = (objName) => {
      if (typeof objName == "undefined")
        return;
      let lqxStore = window.localStorage.getItem(cfg.store.itemName);
      if (lqxStore) {
        try {
          lqxStore = JSON.parse(lqxStore);
        } catch (e) {
          warn2("Invalid JSON in localStorage");
          lqxStore = {};
        }
      } else
        lqxStore = {};
      if (!(objName in lqxStore))
        return;
      return lqxStore[objName];
    };
    const getObjValue = (objName) => {
      const objPath = objName.split(".");
      if (objPath[0] === "window")
        objPath.shift();
      if (!(objPath[0] in window))
        return;
      let objPointer = window[objPath[0]];
      for (let i = 1;i < objPath.length; i++) {
        if (!(objPath[i] in objPointer))
          return;
        objPointer = objPointer[objPath[i]];
      }
      return objPointer;
    };
    const set = (objName) => {
      if (typeof objName == "undefined")
        return;
      let lqxStore = window.localStorage.getItem(cfg.store.itemName);
      if (lqxStore) {
        try {
          lqxStore = JSON.parse(lqxStore);
        } catch (e) {
          warn2("Invalid JSON in localStorage");
          lqxStore = {};
        }
      } else
        lqxStore = {};
      const objValue = getObjValue(objName);
      if (objValue === undefined) {
        warn2(`Object ${objName} doesn't exist and could not be stored`);
        return;
      }
      lqxStore[objName] = objValue;
      window.localStorage.setItem(cfg.store.itemName, JSON.stringify(lqxStore));
      if (!vars.store.tracked.includes(objName))
        vars.store.tracked.push(objName);
      return objValue;
    };
    const unset = (objName) => {
      if (typeof objName == "undefined")
        return false;
      let lqxStore = window.localStorage.getItem(cfg.store.itemName);
      if (lqxStore) {
        try {
          lqxStore = JSON.parse(lqxStore);
        } catch (e) {
          warn2("Invalid JSON in localStorage");
          lqxStore = {};
        }
      } else
        lqxStore = {};
      if (!(objName in lqxStore)) {
        warn2(`Object ${objName} is not currently tracked`);
        return false;
      }
      delete lqxStore[objName];
      const trackedIdx = vars.store.tracked.indexOf(objName);
      if (trackedIdx !== -1)
        vars.store.tracked.splice(trackedIdx, 1);
      window.localStorage.setItem(cfg.store.itemName, JSON.stringify(lqxStore));
      return true;
    };
    const update = () => {
      const lqxStore = {}, droppedObjs = [];
      vars.store.tracked.forEach((objName) => {
        const objValue = getObjValue(objName);
        if (objValue === undefined) {
          warn2(`Object ${objName} no longer exists, dropped from store`);
          droppedObjs.push[objName];
        } else
          lqxStore[objName] = objValue;
      });
      if (droppedObjs.length)
        droppedObjs.forEach((objName) => {
          vars.store.tracked.splice(vars.store.tracked.indexOf(objName), 1);
        });
      window.localStorage.setItem(cfg.store.itemName, JSON.stringify(lqxStore));
    };
    return {
      init,
      get,
      set,
      unset,
      update
    };
  })();
  // css/tailwind/breakpoints.json
  var breakpoints_default = {
    xs: {
      width: 320,
      height: 720
    },
    sm: {
      width: 480,
      height: 1080
    },
    md: {
      width: 720,
      height: 1080
    },
    lg: {
      width: 1080,
      height: 1080
    },
    xl: {
      width: 1620,
      height: 1080
    }
  };

  // ../lyquix/js/lib/lyquix/responsive.ts
  var responsive = (() => {
    const init = (customCfg) => {
      if (vars.responsive?.init)
        return;
      vars.responsive = {
        init: false,
        screen: "",
        orientation: "",
        aspectRatio: ""
      };
      cfg.responsive = {
        enabled: true,
        sizes: Object.keys(breakpoints_default),
        breakPoints: Object.values(breakpoints_default).map((v) => v.width)
      };
      if (customCfg)
        cfg.responsive = jQuery.extend(true, cfg.responsive, customCfg);
      if (cfg.responsive.enabled) {
        log("Initializing responsive");
        cfg.responsive.breakPoints.forEach((breakPoint, s) => {
          let cssQuery = "";
          if (s == 0)
            cssQuery = "(max-width: " + (cfg.responsive.breakPoints[s + 1] - 1) + "px)";
          else if (s == cfg.responsive.breakPoints.length - 1)
            cssQuery = "(min-width: " + cfg.responsive.breakPoints[s] + "px)";
          else
            cssQuery = "(min-width: " + cfg.responsive.breakPoints[s] + "px) and (max-width: " + (cfg.responsive.breakPoints[s + 1] - 1) + "px)";
          const mm = window.matchMedia(cssQuery);
          mm.addEventListener("change", (e) => {
            if (e.matches)
              setScreen(s);
          }, { passive: true });
          if (mm.matches)
            setScreen(s);
        });
        if ("orientation" in window.screen) {
          setOrientation();
          window.addEventListener("orientationchange", () => {
            setOrientation();
            setAspectRatio();
          }, { passive: true });
        }
        setAspectRatio();
        window.addEventListener("resize", () => {
          setAspectRatio();
        }, { passive: true });
      }
      vars.responsive.init = true;
    };
    const setScreen = (s) => {
      if (cfg.responsive.sizes[s] != vars.responsive.screen) {
        vars.body.attr("screen", cfg.responsive.sizes[s]);
        vars.responsive.screen = cfg.responsive.sizes[s];
        vars.document.trigger("screensizechange");
        log("Screen size changed", vars.responsive.screen);
      }
    };
    const setOrientation = () => {
      const o = window.screen.orientation.type;
      if (o.indexOf(vars.responsive.orientation) == -1) {
        switch (o) {
          case "portrait-primary":
          case "portrait-secondary":
            vars.responsive.orientation = "portrait";
            vars.body.attr("orientation", "portrait");
            break;
          case "landscape-primary":
          case "landscape-secondary":
            vars.responsive.orientation = "landscape";
            vars.body.attr("orientation", "landscape");
            break;
        }
        log("Screen orientation changed" + vars.responsive.orientation);
      }
      return true;
    };
    const setAspectRatio = () => {
      const arValue = window.innerWidth / window.innerHeight;
      let arLabel = "";
      if (arValue < 0.5)
        arLabel = "ultranarrow";
      else if (arValue >= 0.5 && arValue < 1)
        arLabel = "narrow";
      else if (arValue >= 1 && arValue < 1.5)
        arLabel = "standard";
      else if (arValue >= 1.5 && arValue < 2)
        arLabel = "wide";
      else if (arValue >= 2)
        arLabel = "ultrawide";
      if (vars.responsive.aspectRatio != arLabel) {
        vars.responsive.aspectRatio = arLabel;
        vars.body.attr("aspectratio", vars.responsive.aspectRatio);
        vars.document.trigger("aspectratiochange");
        log("Aspect ratio changed", vars.responsive.aspectRatio);
      }
    };
    return Object.defineProperties({
      init
    }, {
      screen: {
        get() {
          return vars.responsive.screen;
        },
        set() {
          return;
        }
      },
      orientation: {
        get() {
          return vars.responsive.orientation;
        },
        set() {
          return;
        }
      },
      aspectRatio: {
        get() {
          return vars.responsive.aspectRatio;
        },
        set() {
          return;
        }
      }
    });
  })();

  // ../lyquix/js/lib/lyquix/theme.ts
  var theme = (() => {
    const init = (customCfg) => {
      if (vars.theme?.init)
        return;
      vars.theme = {
        init: false,
        systemPref: "",
        userPref: ""
      };
      cfg.theme = {
        enabled: true
      };
      if (customCfg)
        cfg.theme = jQuery.extend(true, cfg.theme, customCfg);
      if (cfg.theme.enabled) {
        log("Initializing theme");
        const systemPref = window.matchMedia("(prefers-color-scheme: dark)");
        if (systemPref.matches)
          vars.theme.systemPref = "dark";
        else
          vars.theme.systemPref = "light";
        systemPref.addEventListener("change", (e) => {
          if (e.matches)
            vars.theme.systemPref = "dark";
          else
            vars.theme.systemPref = "light";
          setAttribute();
        });
        const userPref = store.get("lqx.vars.theme.userPref");
        if (userPref)
          vars.theme.userPref = userPref;
        setAttribute();
      }
      vars.theme.init = true;
    };
    const get = () => {
      return vars.theme.userPref ? vars.theme.userPref : vars.theme.systemPref;
    };
    const set = (userPref) => {
      if (userPref !== "dark" && userPref !== "light") {
        warn2('Invalid theme preference, must be "dark" or "light"', userPref);
        return;
      }
      vars.theme.userPref = userPref;
      setAttribute();
      store.set("lqx.vars.theme.userPref");
    };
    const reset = () => {
      vars.theme.userPref = "";
      setAttribute();
      store.unset("lqx.vars.theme.userPref");
    };
    const setAttribute = () => {
      vars.body.attr("theme", vars.theme.userPref ? vars.theme.userPref : vars.theme.systemPref);
    };
    return Object.defineProperties({
      init,
      get,
      set,
      reset
    }, {
      systemPref: {
        get() {
          return vars.theme.systemPref;
        },
        set() {
          return;
        }
      },
      userPref: {
        get() {
          return vars.theme.userPref;
        },
        set() {
          return;
        }
      }
    });
  })();

  // ../lyquix/js/lib/lyquix/video.ts
  var video = (() => {
    const init = (customCfg) => {
      if (vars.video?.init)
        return;
      vars.video = {
        init: false
      };
      cfg.video = {
        enabled: true,
        lazyLoadSelector: "video.lazyload-video",
        hoverPlaySelector: "video.video-hover-play",
        viewportPlaySelector: "video.video-viewport-play"
      };
      if (customCfg)
        cfg.video = jQuery.extend(true, cfg.video, customCfg);
      if (cfg.video.enabled) {
        log("Initializing util");
      }
      vars.document.ready(() => {
        lazyLoad(document.querySelectorAll(cfg.video.lazyLoadSelector));
        mutation.addHandler("addNode", cfg.video.lazyLoadSelector, lazyLoad);
        hoverPlay(document.querySelectorAll(cfg.video.hoverPlaySelector));
        mutation.addHandler("addNode", cfg.video.hoverPlaySelector, lazyLoad);
        viewportPlay(document.querySelectorAll(cfg.video.viewportPlaySelector));
        mutation.addHandler("addNode", cfg.video.viewportPlaySelector, lazyLoad);
      });
      vars.video.init = true;
    };
    const lazyLoad = (elems) => {
      const lazyObserver = new IntersectionObserver((videos = elems, observer) => {
        videos.forEach((entry) => {
          if (entry.isIntersecting) {
            const video2 = entry.target;
            if (!video2.src && video2.dataset.src) {
              video2.src = video2.dataset.src;
              video2.load();
            }
            observer.unobserve(video2);
          }
        });
      });
      if (elems.length !== undefined) {
        elems.forEach((video2) => lazyObserver.observe(video2));
      } else {
        lazyObserver.observe(elems);
      }
    };
    const hoverPlay = (elems) => {
      elems.forEach((video2) => {
        video2.addEventListener("mouseenter", () => video2.play());
        video2.addEventListener("mouseleave", () => {
          video2.pause();
          video2.currentTime = 0;
        });
      });
    };
    const viewportPlay = (elems) => {
      const viewportObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video2 = entry.target;
          if (entry.isIntersecting) {
            video2.play();
          } else {
            video2.pause();
          }
        });
      }, {
        threshold: 0.5
      });
      if (elems.length !== undefined) {
        elems.forEach((video2) => viewportObserver.observe(video2));
      } else {
        viewportObserver.observe(elems);
      }
    };
    return {
      init
    };
  })();

  // ../lyquix/js/lib/lyquix/menu.ts
  var menu = (() => {
    const init = (customCfg) => {
      if (vars.menu?.init)
        return;
      vars.menu = {
        init: false,
        type: "basic"
      };
      cfg.menu = {
        enabled: true,
        headerSelector: "header",
        mobileToggleSelector: "#menu-toggle",
        searchToggleSelector: "#search-toggle",
        megaMenuSelector: ".open-side-menu",
        accordionMenuSelector: ".accordion-menu",
        subMenuCloseSelector: "#sub-menu-close"
      };
      if (customCfg)
        cfg.menu = jQuery.extend(true, cfg.menu, customCfg);
      if (cfg.menu.enabled) {
        log("Initializing `menu`");
        vars.document.ready(() => {
          setup(jQuery(cfg.menu.mobileToggleSelector), jQuery(cfg.menu.searchToggleSelector), jQuery(cfg.menu.megaMenuSelector), jQuery(cfg.menu.accordionMenuSelector), jQuery(cfg.menu.subMenuCloseSelector));
        });
        vars.window.on("scroll", function() {
          if (jQuery(this).scrollTop() > 1) {
            jQuery(cfg.menu.headerSelector).addClass("scrolled");
          } else {
            jQuery(cfg.menu.headerSelector).removeClass("scrolled");
            if (jQuery("body").attr("screen") == "lg" || jQuery("body").attr("screen") == "xl") {
              jQuery("header").removeClass("mobile-menu-open");
            }
          }
        });
        vars.window.on("screensizechange", function() {
          if (jQuery("body").attr("screen") == "lg" || jQuery("body").attr("screen") == "xl") {
            jQuery("header").removeClass("mobile-menu-open");
            jQuery("#search-container").removeClass("open");
            jQuery("header .menu li").removeClass("open");
            jQuery("header .menu li").removeClass("accordion-open");
          }
        });
        vars.menu.init = true;
      }
    };
    const setup = (menuElems) => {
      jQuery(menuElems).click(() => {
        jQuery("header").toggleClass("mobile-menu-open");
      });
      jQuery("#search-container button").click(function() {
        jQuery("#search-container").toggleClass("open");
      });
      jQuery(".open-submenu").click(function() {
        jQuery(this).closest("li").addClass("open");
      });
      jQuery(".return-link").click(function() {
        jQuery(this).closest("li").removeClass("open");
      });
      jQuery(".open-accordion-submenu").click(function() {
        jQuery(this).closest("li").toggleClass("accordion-open");
      });
    };
    return {
      init
    };
  })();

  // ../lyquix/js/lib/lyquix/accordion.ts
  var accordion = (() => {
    const init = (customCfg) => {
      if (vars.accordion?.init)
        return;
      vars.accordion = {
        init: false
      };
      cfg.accordion = {
        enabled: true,
        accordionSelector: ".lqx-block-accordion > .accordion",
        headerSelector: ".accordion-header",
        panelSelector: ".accordion-panel",
        analytics: {
          enabled: true,
          nonInteraction: true,
          onClose: true
        }
      };
      if (customCfg)
        cfg.accordion = jQuery.extend(true, cfg.accordion, customCfg);
      if (cfg.accordion.enabled) {
        log("Initializing accordion");
        cfg.accordion.analytics.enabled = cfg.analytics.enabled ? cfg.accordion.analytics.enabled : false;
        if (cfg.accordion.analytics.enabled)
          log("Setting accordions tracking");
        vars.document.ready(() => {
          setup(jQuery(cfg.accordion.accordionSelector));
          hashChangeHandler();
          window.addEventListener("hashchange", hashChangeHandler);
          mutation.addHandler("addNode", cfg.accordion.accordionSelector, setup);
        });
      }
      vars.accordion.init = true;
    };
    const setup = (elems) => {
      if (elems.length) {
        log("Setting up " + elems.length + " accordions", elems);
        elems.each((idx, accElem) => {
          accElem = jQuery(accElem);
          const s = util.validateData({
            openOnLoad: accElem.attr("data-open-on-load") ?? "",
            openMultiple: accElem.attr("data-open-multiple") ?? "",
            browserHistory: accElem.attr("data-browser-history") ?? "",
            autoScroll: (accElem.attr("data-auto-scroll") || "").split(",").filter((x) => x)
          }, {
            type: "object",
            keys: {
              openOnLoad: util.schemaStrReqN,
              openMultiple: util.schemaStrReqY,
              browserHistory: util.schemaStrReqN,
              autoScroll: {
                type: "array",
                required: true,
                default: [],
                elems: {
                  type: "string",
                  allowed: ["xs", "sm", "md", "lg", "xl"]
                }
              }
            }
          });
          if (!s || !s.isValid) {
            error("Invalid accordion settings", accElem);
            return;
          }
          accElem.data("settings", s.data);
          accElem.find(cfg.accordion.headerSelector).each((idx2, headerElem) => {
            headerElem = jQuery(headerElem);
            const panelElem = jQuery("#" + headerElem.attr("id").replace("-header-", "-panel-"));
            if (!panelElem.length) {
              warn2("Accordion panel element not found", headerElem.attr("id"));
              return;
            }
            const panelId = panelElem.attr("id");
            headerElem.on("click", () => {
              if (panelElem.hasClass("closed"))
                open(panelId);
              else
                close(panelId);
            });
          });
        });
      }
    };
    const open = (panelId) => {
      log("Opening accordion", panelId);
      const panelElem = jQuery("#" + panelId);
      const headerElem = jQuery("#" + panelId.replace("-panel-", "-header-"));
      const accElem = panelElem.parents(".accordion");
      if (!panelElem.length || !headerElem.length || !accElem.length) {
        warn2("Accordion elements not found", panelId);
        return;
      }
      const s = accElem.data("settings");
      if (!s)
        return;
      panelElem.removeClass("closed");
      panelElem.attr("aria-hidden", "false");
      headerElem.attr("aria-expanded", "true");
      if (s.autoScroll.includes(responsive.screen)) {
      }
      if (s.browserHistory == "y") {
      }
      if (s.openMultiple == "n") {
        accElem.find(cfg.accordion.panelSelector).not(panelElem).each((idx, elem) => {
          close(jQuery(elem).attr("id"));
        });
      }
      if (cfg.accordion.analytics.enabled) {
        analytics.sendGAEvent({
          eventCategory: "Accordion",
          eventAction: "Open",
          eventLabel: headerElem.text(),
          nonInteraction: cfg.accordion.analytics.nonInteraction
        });
      }
    };
    const close = function(panelId) {
      log("Closing accordion", panelId);
      const panelElem = jQuery("#" + panelId);
      const headerElem = jQuery("#" + panelId.replace("-panel-", "-header-"));
      if (!panelElem.length || !headerElem.length) {
        warn2("Accordion elements not found", panelId);
        return;
      }
      panelElem.addClass("closed");
      panelElem.attr("aria-hidden", "true");
      headerElem.attr("aria-expanded", "false");
      if (cfg.accordion.analytics.enabled && cfg.accordion.analytics.onClose) {
        analytics.sendGAEvent({
          eventCategory: "Accordion",
          eventAction: "Close",
          eventLabel: headerElem.text(),
          nonInteraction: cfg.accordion.analytics.nonInteraction
        });
      }
    };
    const hashChangeHandler = () => {
      const hash = window.location.hash;
      if (hash) {
        const target = jQuery(`.accordion-item${hash}`);
        if (target.length) {
          const panelId = target.find(cfg.accordion.panelSelector).attr("id");
          open(panelId);
        }
      }
    };
    return {
      init,
      open,
      close,
      setup
    };
  })();

  // ../lyquix/js/lib/lyquix/alerts.ts
  var alerts = (() => {
    const init = (customCfg) => {
      if (vars.alerts?.init)
        return;
      vars.alerts = {
        alerts: []
      };
      cfg.alerts = {
        enabled: true,
        alertsModuleSelector: "#lqx-module-alerts > .alerts",
        swiperWrapperSelector: ".swiper-wrapper",
        swiperSelector: ".swiper",
        swiperSlideClass: "swiper-slide",
        swiperNextSelector: ".swiper-button-next",
        swiperPrevSelector: ".swiper-button-prev",
        paginationSelector: ".swiper-pagination",
        analytics: {
          enabled: true,
          nonInteraction: true,
          onClose: true,
          onPrevNext: true
        }
      };
      if (customCfg)
        cfg.alerts = jQuery.extend(true, cfg.alerts, customCfg);
      if (cfg.alerts.enabled) {
        log("Initializing `alerts`");
        cfg.alerts.analytics.enabled = cfg.analytics.enabled ? cfg.alerts.analytics.enabled : false;
        if (cfg.alerts.analytics.enabled)
          log("Setting alerts tracking");
        vars.document.ready(function() {
          setup();
        });
      }
      vars.alerts.init = true;
    };
    const setup = function() {
      const alertsModuleElem = jQuery(cfg.alerts.alertsModuleSelector);
      if (alertsModuleElem.length == 0)
        return;
      log("Setting up alerts", alertsModuleElem);
      const s = util.validateData({
        autoplay: alertsModuleElem.attr("data-autoplay") ?? "",
        autoplayDelay: alertsModuleElem.attr("data-autoplay-delay") ?? "",
        pagination: alertsModuleElem.attr("data-show-pagination") ?? "",
        swiperOptionsOverride: alertsModuleElem.attr("data-swiper-options-override") ?? "",
        headingStyle: alertsModuleElem.attr("data-heading-style") ?? ""
      }, {
        type: "object",
        keys: {
          autoplay: util.schemaStrReqY,
          autoplayDelay: {
            type: "integer",
            required: true,
            default: 15,
            range: [0, 60]
          },
          pagination: util.schemaStrReqY,
          swiperOptionsOverride: util.schemaStrReqEmp,
          headingStyle: {
            type: "string",
            required: true,
            default: "h3",
            allowed: ["p", "h1", "h2", "h3", "h4", "h5", "h6"]
          }
        }
      });
      if (!s || !s.isValid) {
        error("Invalid alerts settings", alertsModuleElem);
        return;
      }
      alertsModuleElem.data("settings", s.data);
      jQuery.ajax({
        cache: false,
        data: {},
        dataType: "json",
        error: function(xhr, status, errorMsg) {
          error("There has been an error trying to fetch alerts from site options", status, errorMsg);
        },
        success: (data) => {
          if (data.length > 0) {
            const settings = alertsModuleElem.data("settings");
            const autoplay = settings.autoplay === "y";
            const autoplayDelay = settings.autoplayDelay;
            const pagination = settings.pagination === "y";
            const headingStyle = settings.headingStyle;
            const now = new Date().getTime();
            data.forEach((rawAlert) => {
              const a = util.validateData(rawAlert, {
                type: "object",
                keys: {
                  id: util.schemaStrReqNotEmp,
                  heading: util.schemaStrReqEmp,
                  body: util.schemaStrReqEmp,
                  expiration: util.schemaStrReqEmp,
                  link: {
                    type: "object",
                    required: true,
                    default: {},
                    keys: {
                      url: util.schemaStrReqEmp,
                      target: util.schemaStrReqEmp,
                      title: util.schemaStrReqEmp
                    }
                  }
                }
              });
              if (!a || !a.isValid) {
                warn2("Invalid alert data, skipping", rawAlert);
                return;
              }
              const alert = a.data;
              if (util.cookie(alert.id) !== null)
                return;
              if (alert.expiration != "" && now > dayjs(alert.expiration).valueOf())
                return;
              if (!alert.heading && !alert.body)
                return;
              let html = `<section id="${alert.id}" class="${cfg.alerts.swiperSlideClass}">`;
              if (alert.heading) {
                html += headingStyle == "p" ? '<p class="title"><strong>' : `<${headingStyle}>`;
                html += alert.heading;
                html += headingStyle == "p" ? "</strong></p>" : `</${headingStyle}>`;
              }
              html += alert.body;
              if (alert.link.url) {
                html += `<a href="${alert.link.url}" ${alert.link.target ? ' target="_blank"' : ""}>`;
                html += alert.link.title ? alert.link.title : "Read More";
                html += "</a>";
              }
              html += "</section>";
              jQuery(html).appendTo(alertsModuleElem.find(cfg.alerts.swiperWrapperSelector));
              log("Alert added: " + alert.heading);
              vars.alerts.alerts.push(alert);
            });
            const count = alertsModuleElem.find(cfg.alerts.swiperWrapperSelector).children().length;
            if (count > 0) {
              alertsModuleElem.removeClass("hidden");
              if (count === 1) {
                alertsModuleElem.find(".controls").remove();
              } else {
                let swiperOptions = {
                  direction: "horizontal",
                  loop: true,
                  slidesPerView: 1,
                  navigation: {
                    prevEl: alertsModuleElem.find(cfg.alerts.swiperPrevSelector)[0],
                    nextEl: alertsModuleElem.find(cfg.alerts.swiperNextSelector)[0]
                  }
                };
                if (pagination == true) {
                  swiperOptions["pagination"] = {
                    el: alertsModuleElem.find(cfg.alerts.paginationSelector)[0],
                    clickable: true,
                    renderBullet: function(index, className) {
                      return '<span class="' + className + '">' + (index + 1) + "</span>";
                    }
                  };
                }
                if (autoplay == true) {
                  swiperOptions["autoplay"] = {
                    delay: autoplayDelay * 1000,
                    pauseOnMouseEnter: true
                  };
                }
                if (settings.swiperOptionsOverride) {
                  try {
                    swiperOptions = jQuery.extend(true, swiperOptions, JSON.parse(settings.swiperOptionsOverride));
                  } catch (e) {
                    warn2("Swiper options override is not valid JSON");
                  }
                }
                new Swiper(cfg.alerts.alertsModuleSelector + " " + cfg.alerts.swiperSelector, swiperOptions);
              }
              alertsModuleElem.find(".close").click(() => {
                vars.alerts.alerts.forEach((alert) => {
                  util.cookie(alert.id, "1", {
                    path: "/",
                    maxAge: alert.expiration ? dayjs(alert.expiration).diff(dayjs(), "second") : 60 * 60 * 24 * 365
                  });
                });
                alertsModuleElem.remove();
                log("Alerts closed");
                if (cfg.alerts.analytics.enabled) {
                  analytics.sendGAEvent({
                    eventCategory: "Alerts",
                    eventAction: "Close",
                    eventLabel: "",
                    nonInteraction: cfg.alerts.analytics.nonInteraction
                  });
                }
              });
              alertsModuleElem.find(cfg.alerts.swiperPrevSelector).click(() => {
                if (cfg.alerts.analytics.enabled && cfg.alerts.analytics.onPrevNext) {
                  analytics.sendGAEvent({
                    eventCategory: "Alerts",
                    eventAction: "Previous",
                    eventLabel: "",
                    nonInteraction: cfg.alerts.analytics.nonInteraction
                  });
                }
              });
              alertsModuleElem.find(cfg.alerts.swiperNextSelector).click(() => {
                if (cfg.alerts.analytics.enabled && cfg.alerts.analytics.onPrevNext) {
                  analytics.sendGAEvent({
                    eventCategory: "Alerts",
                    eventAction: "Next",
                    eventLabel: "",
                    nonInteraction: cfg.alerts.analytics.nonInteraction
                  });
                }
              });
            } else {
              alertsModuleElem.remove();
              log("All alerts were expired or closed");
            }
          } else {
            alertsModuleElem.remove();
            log("No alerts to show");
          }
        },
        url: cfg.siteURL + "/wp-json/lyquix/v3/alerts"
      });
    };
    return {
      init
    };
  })();

  // ../lyquix/js/lib/lyquix/cards.ts
  var cards = (() => {
    const init = (customCfg) => {
      if (vars.cards?.init)
        return;
      vars.cards = {};
      cfg.cards = {
        enabled: true,
        cardsBlockSelector: ".lqx-block-cards > .cards",
        swiperWrapperSelector: ".swiper-wrapper",
        swiperSelector: ".swiper",
        swiperSlideClass: "swiper-slide",
        swiperNextSelector: ".swiper-button-next",
        swiperPrevSelector: ".swiper-button-prev",
        analytics: {
          enabled: true,
          nonInteraction: true,
          onPrevNext: true
        }
      };
      if (customCfg)
        cfg.cards = jQuery.extend(true, cfg.cards, customCfg);
      if (cfg.cards.enabled) {
        log("Initializing `cards`");
        vars.document.ready(() => {
          setup(jQuery(cfg.cards.cardsBlockSelector));
          mutation.addHandler("addNode", cfg.cards.cardsBlockSelector, setup);
        });
      }
      vars.cards.init = true;
    };
    const setup = (elems) => {
      if (elems.length) {
        log("Setting up " + elems.length + " galleries", elems);
        elems.each((idx, cardsElem) => {
          cardsElem = jQuery(cardsElem);
          if (cardsElem.find(cfg.cards.swiperSelector).length == 0)
            return;
          let swiperOptions = {
            direction: "horizontal",
            loop: false,
            slidesPerView: 1,
            breakpoints: {},
            navigation: {
              prevEl: cfg.cards.swiperPrevSelector,
              nextEl: cfg.cards.swiperNextSelector
            }
          };
          try {
            const responsiveRules = JSON.parse(cardsElem.attr("data-responsive-rules"));
            if (Array.isArray(responsiveRules)) {
              responsiveRules.forEach((rule) => {
                rule.screens.forEach((screen) => {
                  swiperOptions.breakpoints[cfg.responsive.breakPoints[cfg.responsive.sizes.indexOf(screen)]] = {
                    slidesPerView: parseInt(rule.columns)
                  };
                });
              });
            }
          } catch (e) {
            warn2("Responsive rules is not valid JSON");
          }
          try {
            const swiperOptionsOverride = JSON.parse(cardsElem.attr("data-swiper-options-override"));
            swiperOptions = jQuery.extend(true, swiperOptions, swiperOptionsOverride);
          } catch (e) {
            warn2("Swiper options override is not valid JSON");
          }
          new Swiper("#" + cardsElem.attr("id") + " " + cfg.cards.swiperSelector, swiperOptions);
          cardsElem.find(`${cfg.cards.swiperPrevSelector}, ${cfg.cards.swiperNextSelector}`).click((event) => {
            if (cfg.cards.analytics.enabled && cfg.cards.analytics.onPrevNext) {
              analytics.sendGAEvent({
                eventCategory: "Cards",
                eventAction: jQuery(event.target).hasClass(cfg.cards.swiperPrevSelector.replace(".", "")) ? "Previous" : "Next",
                eventLabel: "",
                nonInteraction: cfg.cards.analytics.nonInteraction
              });
            }
          });
        });
      }
    };
    return {
      init
    };
  })();

  // ../lyquix/js/lib/lyquix/filters.ts
  var filters = (() => {
    const init = (customCfg) => {
      if (vars.filters?.init)
        return;
      vars.filters = {
        init: false,
        hash: null,
        filters: {},
        useHashFilterId: null,
        cache: {}
      };
      cfg.filters = {
        enabled: true,
        filtersSelector: ".lqx-block-filters > .filters",
        controlsSelector: ".controls",
        openButtonSelector: ".open-close-wrapper > .open",
        closeButtonSelector: ".open-close-wrapper > .close",
        controlTabsSelector: ".control-tabs",
        controlWrapperSelector: ".control-wrapper",
        searchWrapperSelector: ".search-wrapper",
        searchInputSelector: ".search",
        searchButtonSelector: ".search-button",
        clearWrapperSelector: ".clear-wrapper",
        orderWrapperSelector: ".order-wrapper",
        clearButtonSelector: ".clear",
        postsSelector: ".posts",
        paginationSelector: ".pagination",
        firstPageSelector: ".page-first",
        prevPageSelector: ".page-prev",
        nextPageSelector: ".page-next",
        lastPageSelector: ".page-last",
        pageNumberSelector: ".page-number",
        postsPerPageWrapperSelector: ".pagination > .posts-per-page-wrapper",
        postsPerPageSelector: ".posts-per-page",
        mapSelector: ".lqx-block-map",
        analytics: {
          enabled: true,
          nonInteraction: false
        }
      };
      if (customCfg)
        cfg.filters = jQuery.extend(true, cfg.filters, customCfg);
      if (cfg.filters.enabled) {
        log("Initializing filters");
        cfg.filters.analytics.enabled = cfg.analytics.enabled ? cfg.filters.analytics.enabled : false;
        if (cfg.filters.analytics.enabled)
          log("Setting filters tracking");
        vars.document.ready(() => {
          setup(jQuery(cfg.filters.filtersSelector));
          parseHash();
          vars.window.on("hashchange", () => {
            if (vars.filters.useHashFilterId !== null && vars.filters.useHashFilterId in vars.filters.filters)
              parseHash();
          });
          mutation.addHandler("addNode", cfg.filters.filtersSelector, setup);
        });
      }
      vars.filters.init = true;
    };
    const setup = (elems) => {
      if (elems.length) {
        log("Setting up " + elems.length + " filters", elems);
        elems.each((idx, filterElem) => {
          filterElem = jQuery(filterElem);
          const id = jQuery(filterElem).attr("id");
          if (!id) {
            warn2("Filter element does not have an ID", filterElem);
            return;
          }
          let settings;
          try {
            settings = JSON.parse(jQuery(filterElem).attr("data-settings") || "{}");
          } catch (e) {
            warn2("Filter element has invalid JSON settings", filterElem);
            return;
          }
          if (!settings || typeof settings !== "object") {
            warn2("Filter element does not have settings", filterElem);
            return;
          }
          if (id != settings.hash) {
            warn2("Filter element ID does not match settings.hash", filterElem);
            return;
          }
          if (settings.use_hash == "y" && !vars.filters.useHashFilterId)
            vars.filters.useHashFilterId = id;
          const filterObj = {
            id,
            elem: filterElem,
            initial: jQuery.extend(true, {}, settings.controls),
            ...settings
          };
          vars.filters.filters[id] = filterObj;
          if (filterObj.render_mode == "js")
            render(id);
          addListeners(id);
        });
      }
    };
    const render = (id) => {
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      renderControls(id);
      renderPosts(id);
      renderPagination(id);
      renderPills(id);
      vars.filters.filters[id].elem.removeClass("loading");
      if (typeof vars.filters.filters[id].callback === "string" && vars.filters.filters[id].callback !== "") {
        vars.filters.filters[id].callback.split(".").reduce((o, k) => o?.[k], window)?.();
      }
    };
    const renderControls = (id) => {
      log("Filters renderControls");
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      const filterObj = vars.filters.filters[id];
      let controls;
      switch (filterObj.render_mode) {
        case "js":
          break;
        case "php":
          const $rendered = jQuery(filterObj.render.controls);
          const $newControls = $rendered.filter(cfg.filters.controlsSelector);
          controls = filterObj.elem.find(cfg.filters.controlsSelector);
          if (controls.length)
            controls.replaceWith($newControls.length ? $newControls : $rendered);
          else
            filterObj.elem.prepend($newControls.length ? $newControls : $rendered);
          break;
      }
    };
    const renderPosts = (id) => {
      log("Filters renderPosts");
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      const filterObj = vars.filters.filters[id];
      let posts;
      switch (filterObj.render_mode) {
        case "js":
          break;
        case "php":
          posts = filterObj.elem.find(`${cfg.filters.postsSelector}, .no-results`);
          if (posts.length)
            posts.replaceWith(filterObj.render.posts);
          else
            filterObj.elem.append(filterObj.render.posts);
          break;
        case "maps-php":
          posts = filterObj.elem.find(cfg.filters.mapSelector);
          if (posts.length)
            posts.replaceWith(filterObj.render.posts);
          else
            filterObj.elem.append(filterObj.render.posts);
          let controls = filterObj.elem.find(cfg.filters.controlsSelector);
          if (controls.length)
            controls.replaceWith(filterObj.render.controls);
          else
            filterObj.elem.append(filterObj.render.controls);
          break;
      }
    };
    const renderPagination = (id) => {
      log("Filters renderPagination");
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      const filterObj = vars.filters.filters[id];
      let pagination;
      switch (filterObj.render_mode) {
        case "js":
          break;
        case "php":
          pagination = filterObj.elem.find(cfg.filters.paginationSelector);
          if (pagination.length)
            pagination.replaceWith(filterObj.render.pagination);
          else
            filterObj.elem.append(filterObj.render.pagination);
          break;
      }
    };
    const renderPills = (id) => {
      const filterObj = vars.filters.filters[id];
      if (!filterObj)
        return;
      const pillsWrapper = filterObj.elem.find(`#${id}-pills`);
      if (!pillsWrapper.length)
        return;
      pillsWrapper.empty();
      const selectedControls = filterObj.controls.filter((control) => control.selected !== "");
      if (!selectedControls.length)
        return;
      pillsWrapper.append(`<div class="clear-wrapper"><button class="pill clear">${filterObj.clear_label ?? "Clear"}</button></div>`);
      selectedControls.forEach((control) => {
        const option = control.options.find((opt) => opt.value == control.selected);
        const label = option ? option.text : control.selected;
        pillsWrapper.append(`<button class="pill" data-control="${control.slug}" data-active-value="${control.selected}">${label}</button>`);
      });
    };
    const findFilterElems = (filterObj, selector) => {
      const insideFilter = filterObj.elem.find(selector);
      const idPrefix = filterObj.id + "-";
      const outsideFilter = jQuery(selector).filter((idx, el) => {
        const elemId = jQuery(el).attr("id");
        return typeof elemId === "string" && elemId.startsWith(idPrefix);
      });
      return insideFilter.add(outsideFilter);
    };
    const addListeners = (id) => {
      log("Filters addListeners");
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      const filterObj = vars.filters.filters[id];
      findFilterElems(filterObj, cfg.filters.openButtonSelector).off("click.lqxfilters").on("click.lqxfilters", (e) => {
        e.preventDefault();
        filterObj.elem.find(cfg.filters.controlsSelector).addClass("open");
      });
      findFilterElems(filterObj, cfg.filters.closeButtonSelector).off("click.lqxfilters").on("click.lqxfilters", (e) => {
        e.preventDefault();
        filterObj.elem.find(cfg.filters.controlsSelector).removeClass("open");
      });
      findFilterElems(filterObj, cfg.filters.controlTabsSelector).each((idx, controlTabs) => {
        controlTabs = jQuery(controlTabs);
        controlTabs.find("button").off("click.lqxfilters").on("click.lqxfilters", (e) => {
          e.preventDefault();
          const button = jQuery(e.target);
          controlTabs.find("li").removeClass("active");
          button.parent().addClass("active");
          const controlName = button.attr("data-control");
          findFilterElems(filterObj, cfg.filters.controlWrapperSelector).each((idx2, controlWrapper) => {
            controlWrapper = jQuery(controlWrapper);
            if (controlWrapper.attr("data-control") == controlName)
              controlWrapper.addClass("active");
            else
              controlWrapper.removeClass("active");
          });
        });
      });
      findFilterElems(filterObj, cfg.filters.controlWrapperSelector).each((idx, controlWrapper) => {
        controlWrapper = jQuery(controlWrapper);
        controlWrapper.find('select, input[type="radio"], input[type="checkbox"], ul, button').each((idx2, control) => {
          control = jQuery(control);
          const controlName = controlWrapper.attr("data-control");
          switch (control.prop("tagName").toLowerCase()) {
            case "select":
              control.off("change.lqxfilters").on("change.lqxfilters", () => {
                if (controlWrapper.attr("data-control-type") == "distance") {
                  const searchQueryEl = filterObj.elem.find('[data-control="distance"] .search');
                  var geocoder = new google.maps.Geocoder;
                  const address = searchQueryEl.val();
                  geocoder.geocode({ address, region: "us" }, function(results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                      const miles = controlWrapper.find("select[name=distance]").val();
                      const val = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng(), miles, address };
                      setDistance(id, controlName, val);
                    }
                  });
                } else {
                  controlChange(id, controlName, control.val());
                }
              });
              break;
            case "input":
              switch (control.attr("type")) {
                case "radio":
                  control.off("click.lqxfilters").on("click.lqxfilters", () => {
                    const foundControl = filterObj.controls.find((curr) => curr.slug == controlName);
                    const reduced = foundControl ? foundControl.selected : undefined;
                    if (control.attr("value") == reduced) {
                      controlChange(id, controlName, "");
                      control.prop("checked", false);
                    } else
                      controlChange(id, controlName, control.val());
                  });
                  break;
                case "checkbox":
                  control.off("change.lqxfilters").on("change.lqxfilters", () => {
                    if (control.prop("checked")) {
                      controlWrapper.find('input[type="checkbox"]').each((idx3, checkbox) => {
                        checkbox = jQuery(checkbox);
                        if (checkbox.attr("name") == controlName && checkbox.attr("id") != control.attr("id")) {
                          checkbox.prop("checked", false);
                        }
                      });
                      controlChange(id, controlName, control.val());
                    } else
                      controlChange(id, controlName, "");
                  });
                  break;
              }
              break;
            case "ul":
              control.find("li").each((idx3, li) => {
                li = jQuery(li);
                li.off("click.lqxfilters").on("click.lqxfilters", () => {
                  if (li.hasClass("selected")) {
                    controlChange(id, controlName, "");
                    control.find("li").removeClass("selected");
                  } else {
                    controlChange(id, controlName, li.attr("data-value"));
                    control.find("li").removeClass("selected");
                    li.addClass("selected");
                  }
                });
              });
              controlWrapper.find("label").off("click.lqxfilters").on("click.lqxfilters", () => {
                let controlsSelector = findFilterElems(filterObj, cfg.filters.controlsSelector);
                controlsSelector = jQuery(controlsSelector);
                controlWrapper.siblings().removeClass("open");
                controlWrapper.toggleClass("open");
                if (controlWrapper.hasClass("open")) {
                  controlsSelector.addClass("open-list");
                } else {
                  controlsSelector.removeClass("open-list");
                }
              });
              break;
            case "button":
              if (controlWrapper.attr("data-control-type") == "distance") {
                control.off("click.lqxfilters").on("click.lqxfilters", (e) => {
                  if (control.hasClass("search-button")) {
                    const searchQueryEl = filterObj.elem.find('[data-control="distance"] .search');
                    var geocoder = new google.maps.Geocoder;
                    const address = searchQueryEl.val();
                    geocoder.geocode({ address, region: "us" }, function(results, status) {
                      if (status == google.maps.GeocoderStatus.OK) {
                        const miles = controlWrapper.find("select[name=distance]").val();
                        const val = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng(), miles, address };
                        setDistance(id, controlName, val);
                      }
                    });
                  } else if (control.hasClass("location-button")) {
                    navigator.geolocation.getCurrentPosition(function(loc) {
                      const miles = controlWrapper.find("select[name=distance]").val();
                      const val = { lat: loc.coords["latitude"], lng: loc.coords["longitude"], miles, address: "Current Location" };
                      setDistance(id, controlName, val);
                    });
                  }
                });
              }
              break;
          }
        });
      });
      findFilterElems(filterObj, cfg.filters.searchWrapperSelector).each((idx, searchWrapper) => {
        searchWrapper = jQuery(searchWrapper);
        const parentControl = searchWrapper.closest(cfg.filters.controlWrapperSelector);
        if (parentControl.length && parentControl.attr("data-control-type") === "distance")
          return;
        const searchInput = searchWrapper.find(cfg.filters.searchInputSelector);
        searchInput.off("keyup.lqxfilters").on("keyup.lqxfilters", (e) => {
          if (e.keyCode == 13) {
            e.preventDefault();
            searchChange(id, searchInput.val());
          }
        });
        searchInput.off("focusout.lqxfilters").on("focusout.lqxfilters", () => {
          searchChange(id, searchInput.val());
        });
        const searchButton = searchWrapper.find(cfg.filters.searchButtonSelector);
        searchButton.off("click.lqxfilters").on("click.lqxfilters", (e) => {
          e.preventDefault();
          searchChange(id, searchInput.val());
        });
      });
      findFilterElems(filterObj, cfg.filters.clearWrapperSelector).each((idx, clearWrapper) => {
        clearWrapper = jQuery(clearWrapper);
        const clearButton = clearWrapper.find(cfg.filters.clearButtonSelector);
        clearButton.off("click.lqxfilters").on("click.lqxfilters", (e) => {
          e.preventDefault();
          reset(id);
        });
      });
      findFilterElems(filterObj, cfg.filters.orderWrapperSelector).each((idx, orderWrapper) => {
        orderWrapper = jQuery(orderWrapper);
        orderWrapper.find(".option").each((idx2, option) => {
          option = jQuery(option);
          option.off("click.lqxfilters").on("click.lqxfilters", (e) => {
            e.preventDefault();
            vars.filters.filters[id].posts_order[0] = { order_by: option.attr("data-value"), order: option.attr("data-order") };
            callAPI(id);
          });
        });
      });
      filterObj.elem.find(cfg.filters.paginationSelector).each((idx, pagination) => {
        pagination = jQuery(pagination);
        pagination.find(cfg.filters.firstPageSelector).on("click", (e) => {
          e.preventDefault();
          if (jQuery(e.target).hasClass("inactive"))
            return;
          pageChange(id, "first");
        });
        pagination.find(cfg.filters.prevPageSelector).on("click", (e) => {
          e.preventDefault();
          if (jQuery(e.target).hasClass("inactive"))
            return;
          pageChange(id, "prev");
        });
        pagination.find(cfg.filters.nextPageSelector).on("click", (e) => {
          e.preventDefault();
          if (jQuery(e.target).hasClass("inactive"))
            return;
          pageChange(id, "next");
        });
        pagination.find(cfg.filters.lastPageSelector).on("click", (e) => {
          e.preventDefault();
          if (jQuery(e.target).hasClass("inactive"))
            return;
          pageChange(id, "last");
        });
        pagination.find(cfg.filters.pageNumberSelector).on("click", (e) => {
          e.preventDefault();
          pageChange(id, parseInt(jQuery(e.target).attr("data-page")));
        });
      });
      filterObj.elem.find(cfg.filters.postsPerPageWrapperSelector).each((idx, postsPerPageWrapper) => {
        postsPerPageWrapper = jQuery(postsPerPageWrapper);
        const postsPerPage = postsPerPageWrapper.find(cfg.filters.postsPerPageSelector);
        postsPerPage.off("change.lqxfilters").on("change.lqxfilters", () => {
          postsPerPageChange(id, postsPerPage.val());
        });
      });
      jQuery("body").off("click.lqxfilters-" + id).on("click.lqxfilters-" + id, (e) => {
        const clickedControl = jQuery(e.target).closest(cfg.filters.controlWrapperSelector).filter((idx, el) => {
          const elemId = jQuery(el).attr("id");
          return typeof elemId === "string" && elemId.startsWith(filterObj.id + "-");
        });
        if (!clickedControl.length) {
          findFilterElems(filterObj, cfg.filters.controlWrapperSelector).each((idx, controlWrapper) => {
            jQuery(controlWrapper).removeClass("open").removeClass("active");
            findFilterElems(filterObj, cfg.filters.controlsSelector).removeClass("open-list");
          });
        }
      });
      filterObj.elem.find(".pills .pill").each((idx, pill) => {
        pill = jQuery(pill);
        pill.off("click.lqxfilters").on("click.lqxfilters", (e) => {
          const pillEl = jQuery(e.currentTarget);
          if (pillEl.hasClass("clear")) {
            reset(id);
            return;
          }
          const controlName = pillEl.attr("data-control");
          const controlWrappers = findFilterElems(filterObj, `${cfg.filters.controlWrapperSelector}[data-control="${controlName}"]`);
          controlWrappers.find("select").val("");
          controlWrappers.find('input[type="radio"], input[type="checkbox"]').prop("checked", false);
          controlWrappers.find("ul li").removeClass("selected");
          controlChange(id, controlName, "");
        });
      });
    };
    const controlChange = (id, controlName, controlValue) => {
      log("Filters controlChange", id, controlName, controlValue);
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      const filterObj = vars.filters.filters[id];
      const control = filterObj.controls.find((control2) => control2.slug == controlName);
      if (!control) {
        warn2("Invalid control name", controlName);
        return;
      }
      if (controlValue !== "") {
        const option = control.options.find((option2) => option2.value == controlValue);
        if (!option) {
          warn2("Invalid option value", controlValue);
          return;
        }
      }
      control.selected = controlValue;
      filterObj.pagination.page = 1;
      if (id == vars.filters.useHashFilterId)
        updateHash();
      callAPI(id);
      if (cfg.filters.analytics.enabled) {
        analytics.sendGAEvent({
          eventCategory: "Filters",
          eventAction: "Control",
          eventLabel: `${controlName}:${controlValue}`,
          nonInteraction: cfg.filters.analytics.nonInteraction
        });
      }
    };
    const setDistance = (id, controlName, controlValue) => {
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      const filterObj = vars.filters.filters[id];
      const control = filterObj.controls.find((control2) => control2.slug == controlName);
      control.miles = controlValue.miles;
      control.lat = controlValue.lat;
      control.lng = controlValue.lng;
      control.address = controlValue.address;
      filterObj.pagination.page = 1;
      if (id == vars.filters.useHashFilterId)
        updateHash();
      callAPI(id);
      if (cfg.filters.analytics.enabled) {
        analytics.sendGAEvent({
          eventCategory: "Filters",
          eventAction: "Control",
          eventLabel: `${controlName}:${controlValue}`,
          nonInteraction: cfg.filters.analytics.nonInteraction
        });
      }
    };
    const searchChange = (id, query) => {
      log("Filters searchChange", id, query);
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      const filterObj = vars.filters.filters[id];
      filterObj.search = query;
      filterObj.pagination.page = 1;
      if (id == vars.filters.useHashFilterId)
        updateHash();
      callAPI(id);
      if (cfg.filters.analytics.enabled) {
        analytics.sendGAEvent({
          eventCategory: "Filters",
          eventAction: "Search",
          eventLabel: query,
          nonInteraction: cfg.filters.analytics.nonInteraction
        });
      }
    };
    const pageChange = (id, page) => {
      log("Filters pageChange", id, page);
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      const filterObj = vars.filters.filters[id];
      if (typeof page == "string" && isNaN(parseInt(page))) {
        switch (page) {
          case "first":
            page = 1;
            break;
          case "prev":
            page = filterObj.pagination.page - 1;
            if (page < 1)
              page = 1;
            break;
          case "next":
            page = filterObj.pagination.page + 1;
            if (page > filterObj.pagination.total_pages)
              page = filterObj.pagination.total_pages;
            break;
          case "last":
            page = filterObj.pagination.total_pages;
            break;
          default:
            warn2("Invalid page keyword", page);
            return;
        }
      }
      if (typeof page == "string")
        page = parseInt(page);
      if (isNaN(page) || page < 1 || page > filterObj.pagination.total_pages) {
        warn2("Invalid page number", page);
        return;
      }
      filterObj.pagination.page = page;
      filterObj.elem.find(cfg.filters.pageNumberSelector).removeClass("current");
      filterObj.elem.find(cfg.filters.pageNumberSelector + '[data-page="' + page + '"]').addClass("current");
      if (id == vars.filters.useHashFilterId)
        updateHash();
      callAPI(id);
      if (cfg.filters.analytics.enabled) {
        analytics.sendGAEvent({
          eventCategory: "Filters",
          eventAction: "Page",
          eventLabel: page.toString(),
          nonInteraction: cfg.filters.analytics.nonInteraction
        });
      }
    };
    const postsPerPageChange = (id, postsPerPage) => {
      log("Filters postsPerPageChange", id, postsPerPage);
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      const filterObj = vars.filters.filters[id];
      postsPerPage = parseInt(postsPerPage);
      if (isNaN(postsPerPage) || !filterObj.pagination.posts_per_page_options.includes(postsPerPage)) {
        warn2("Invalid posts per page number", postsPerPage);
        return;
      }
      filterObj.pagination.posts_per_page = postsPerPage;
      filterObj.pagination.page = 1;
      if (id == vars.filters.useHashFilterId)
        updateHash();
      callAPI(id);
      if (cfg.filters.analytics.enabled) {
        analytics.sendGAEvent({
          eventCategory: "Filters",
          eventAction: "Posts per Page",
          eventLabel: postsPerPage.toString(),
          nonInteraction: cfg.filters.analytics.nonInteraction
        });
      }
    };
    const reset = (id) => {
      log("Filters reset", id);
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      const filterObj = vars.filters.filters[id];
      filterObj.controls.forEach((control) => {
        control.selected = "";
        if (control.type == "distance") {
          control.miles = "";
          control.address = "";
          control.lat = "";
          control.lon = "";
        }
      });
      findFilterElems(filterObj, cfg.filters.controlWrapperSelector).each((idx, controlWrapper) => {
        controlWrapper = jQuery(controlWrapper);
        controlWrapper.find('select, input[type="radio"], input[type="checkbox"], ul').each((idx2, control) => {
          control = jQuery(control);
          switch (control.prop("tagName").toLowerCase()) {
            case "select":
              control.val("");
              break;
            case "input":
              control.prop("checked", false);
              break;
            case "ul":
              control.find("li").removeClass("selected");
              break;
          }
        });
      });
      filterObj.search = "";
      findFilterElems(filterObj, cfg.filters.searchWrapperSelector).find(cfg.filters.searchInputSelector).val("");
      filterObj.pagination.page = 1;
      filterObj.elem.find(cfg.filters.pageNumberSelector).removeClass("current");
      filterObj.elem.find(cfg.filters.pageNumberSelector + '[data-page="1"]').addClass("current");
      if (id == vars.filters.useHashFilterId)
        updateHash();
      callAPI(id);
    };
    const parseHash = () => {
      log("Filters parseHash");
      if (!(vars.filters.useHashFilterId in vars.filters.filters))
        return;
      const filterObj = vars.filters.filters[vars.filters.useHashFilterId];
      const rawHash = window.location.hash.substring(1);
      if (!rawHash.length)
        return;
      let updateNeeded = false;
      const segments = rawHash.split("/");
      let page = segments[segments.length - 1].match(/page-(\d+)/);
      if (page !== null) {
        page = page[1];
        segments.pop();
        log("Page number from hash: " + page);
      } else
        page = 1;
      if (page != filterObj.pagination.page)
        updateNeeded = true;
      filterObj.pagination.page = page;
      filterObj.elem.find(cfg.filters.pageNumberSelector).removeClass("current");
      filterObj.elem.find(cfg.filters.pageNumberSelector + '[data-page="' + page + '"]').addClass("current");
      let search = "";
      if (segments.length) {
        search = segments[segments.length - 1].match(/search:(.+)/);
        if (search != null) {
          search = decodeURIComponent(search[1]);
          segments.pop();
          log("Search query from hash: " + search);
        }
      }
      if (search != filterObj.search)
        updateNeeded = true;
      filterObj.search = search;
      findFilterElems(filterObj, cfg.filters.searchWrapperSelector).find(cfg.filters.searchInputSelector).val(search);
      if (segments.length) {
        segments.forEach((controlStr) => {
          const controlNameVal = controlStr.match(/([^:]+):(.+)/);
          if (controlNameVal == null) {
            warn2("Invalid control segment in hash: " + controlStr);
            return;
          }
          const controlAliases = filterObj.controls.reduce((acc, curr) => {
            if (curr.alias)
              acc[curr.alias] = curr.slug;
            return acc;
          }, {});
          if (controlNameVal[1] in controlAliases)
            controlNameVal[1] = controlAliases[controlNameVal[1]];
          const controlName = controlNameVal[1];
          const controlValueSlug = decodeURIComponent(controlNameVal[2]);
          filterObj.controls = jQuery.extend(true, [], filterObj.initial);
          if (filterObj.controls.map((control) => control.slug).includes(controlName)) {
            let validControlValue = false;
            filterObj.controls.forEach((control) => {
              if (control.slug == controlName) {
                control.options.forEach((option) => {
                  if (option.slug == controlValueSlug) {
                    if (control.selected != option.value.toString())
                      updateNeeded = true;
                    control.selected = option.value.toString();
                    validControlValue = true;
                    log("Control value from hash", controlStr, controlName, option.value);
                    findFilterElems(filterObj, cfg.filters.controlWrapperSelector + '[data-control="' + controlName + '"]').find('select, input[type="radio"], input[type="checkbox"], ul').each((idx, control2) => {
                      control2 = jQuery(control2);
                      switch (control2.prop("tagName").toLowerCase()) {
                        case "select":
                          control2.val(option.value.toString());
                          break;
                        case "input":
                          control2.prop("checked", control2.val() == option.value.toString());
                          break;
                        case "ul":
                          control2.find("li").each((idx2, li) => {
                            li = jQuery(li);
                            if (li.attr("data-value") == option.value.toString())
                              li.addClass("selected");
                            else
                              li.removeClass("selected");
                          });
                          break;
                      }
                    });
                  }
                });
              }
            });
            if (!validControlValue)
              warn2("Invalid control value from hash: " + controlStr);
          } else
            warn2("Invalid filter name from hash: " + controlName);
        });
      }
      if (updateNeeded)
        callAPI(filterObj.id);
    };
    const updateHash = () => {
      log("Filters updateHash");
      const filterObj = vars.filters.filters[vars.filters.useHashFilterId];
      const hash = [];
      filterObj.controls.forEach((control) => {
        if (control.selected) {
          const option = control.options.find((option2) => option2.value == control.selected);
          if (option) {
            hash.push((control.alias ? control.alias : control.slug) + ":" + option.slug);
          }
        }
      });
      if (filterObj.search)
        hash.push("search:" + encodeURIComponent(filterObj.search));
      if (filterObj.pagination.page > 1)
        hash.push("page-" + filterObj.pagination.page);
      vars.filters.hash = hash.join("/");
      history.pushState(null, "", "#" + vars.filters.hash);
    };
    const callAPI = (id) => {
      log("Filters callAPI");
      if (!(id in vars.filters.filters)) {
        warn2("Filter ID not found", id);
        return;
      }
      vars.filters.filters[id].elem.addClass("loading");
      let payload = jQuery.extend(true, {}, vars.filters.filters[id]);
      ["elem", "id", "render_mode", "use_hash"].forEach((key) => delete payload[key]);
      [
        "pagination",
        "pagination_details",
        "show_all",
        "show_posts_per_page",
        "total_pages",
        "total_posts"
      ].forEach((key) => delete payload.pagination[key]);
      payload.controls = payload.controls.map((control) => {
        ["custom_order", "options", "presentation", "visible"].forEach((key) => delete control[key]);
        return control;
      });
      payload = JSON.stringify(payload);
      const payloadHash = util.hash(payload);
      const data = getCache(payloadHash);
      if (data !== null)
        processAPIResponse(data);
      else {
        jQuery.ajax({
          cache: false,
          contentType: "application/json",
          data: payload,
          dataType: "json",
          error: (xhr, status, errorMsg) => {
            error("There has been an error while connecting to the filters API", status, errorMsg);
          },
          method: "POST",
          success: (data2) => {
            setCache(payloadHash, data2);
            processAPIResponse(data2);
          },
          url: cfg.siteURL + "/wp-json/lyquix/v3/filters"
        });
      }
    };
    const processAPIResponse = (data) => {
      log("Filters processAPIResponse");
      if (!data || typeof data !== "object" || !data.hash) {
        warn2("Invalid filters API response", data);
        return;
      }
      const id = data.hash;
      const filterObj = vars.filters.filters[id];
      if (!filterObj) {
        warn2("Filter ID from API response not found", id);
        return;
      }
      vars.filters.filters[id] = jQuery.extend(true, filterObj, data);
      update(id);
    };
    const setCache = (hash, data) => {
      vars.filters.cache[hash] = data;
      if (vars.filters.cache.length > 100) {
        vars.filters.cache.delete(vars.filters.cache.keys().next().value);
      }
      setTimeout(() => delete vars.filters.cache[hash], 300000);
    };
    const getCache = (hash) => {
      if (hash in vars.filters.cache)
        return vars.filters.cache[hash];
      else
        return null;
    };
    const update = (id) => {
      render(id);
      addListeners(id);
      const postsElem = vars.filters.filters[id].elem.find(cfg.filters.postsSelector);
      if (postsElem.offset().top < jQuery(window).scrollTop() || postsElem.offset().top > jQuery(window).scrollTop() + jQuery(window).height() * 0.25) {
        jQuery("html, body").animate({
          scrollTop: postsElem.offset().top - jQuery(window).height() * 0.25
        }, 500);
      }
    };
    return {
      init,
      controlChange,
      searchChange,
      pageChange,
      postsPerPageChange,
      reset
    };
  })();

  // ../lyquix/js/lib/lyquix/gallery.ts
  var gallery = (() => {
    const init = (customCfg) => {
      if (vars.gallery?.init)
        return;
      vars.gallery = {};
      cfg.gallery = {
        enabled: true,
        galleryBlockSelector: ".lqx-block-gallery > .gallery",
        swiperWrapperSelector: ".swiper-wrapper",
        swiperSelector: ".swiper",
        swiperSlideClass: "swiper-slide",
        swiperNextSelector: ".swiper-button-next",
        swiperPrevSelector: ".swiper-button-prev",
        analytics: {
          enabled: true,
          nonInteraction: true,
          onPrevNext: true
        }
      };
      if (customCfg)
        cfg.gallery = jQuery.extend(true, cfg.gallery, customCfg);
      if (cfg.gallery.enabled) {
        log("Initializing `gallery`");
        cfg.gallery.analytics.enabled = cfg.analytics.enabled ? cfg.gallery.analytics.enabled : false;
        if (cfg.gallery.analytics.enabled)
          log("Setting gallery analytics");
        vars.document.ready(() => {
          setup(jQuery(cfg.gallery.galleryBlockSelector));
          mutation.addHandler("addNode", cfg.gallery.galleryBlockSelector, setup);
        });
      }
      vars.gallery.init = true;
    };
    const setup = (elems) => {
      if (elems.length) {
        log("Setting up " + elems.length + " galleries", elems);
        elems.each((idx, galleryElem) => {
          galleryElem = jQuery(galleryElem);
          if (galleryElem.find(cfg.gallery.swiperSelector).length == 0)
            return;
          let swiperOptions = {
            direction: "horizontal",
            loop: true,
            slidesPerView: 1,
            navigation: {
              prevEl: cfg.gallery.swiperPrevSelector,
              nextEl: cfg.gallery.swiperNextSelector
            }
          };
          try {
            const swiperOptionsOverride = JSON.parse(galleryElem.attr("data-swiper-options-override"));
            swiperOptions = jQuery.extend(true, swiperOptions, swiperOptionsOverride);
          } catch (e) {
            warn2("Swiper options override is not valid JSON");
          }
          new Swiper("#" + galleryElem.attr("id") + " " + cfg.gallery.swiperSelector, swiperOptions);
          galleryElem.find(`${cfg.gallery.swiperPrevSelector}, ${cfg.gallery.swiperNextSelector}`).click((event) => {
            if (cfg.gallery.analytics.enabled && cfg.gallery.analytics.onPrevNext) {
              analytics.sendGAEvent({
                eventCategory: "Gallery",
                eventAction: jQuery(event.target).hasClass(cfg.gallery.swiperPrevSelector.replace(".", "")) ? "Previous" : "Next",
                eventLabel: "",
                nonInteraction: cfg.gallery.analytics.nonInteraction
              });
            }
            if (galleryElem.attr("data-browser-history") == "y") {
            }
          });
        });
      }
    };
    return {
      init
    };
  })();

  // ../lyquix/js/lib/lyquix/map.ts
  var map = (() => {
    const init = (customCfg) => {
      if (vars.map?.init)
        return;
      vars.map = {
        init: false,
        maps: []
      };
      cfg.map = {
        enabled: true,
        blockSelector: ".lqx-block-map",
        analytics: {
          enabled: true,
          nonInteraction: true
        }
      };
      if (customCfg)
        cfg.map = jQuery.extend(true, cfg.map, customCfg);
      if (cfg.map.enabled) {
        log("Initializing map");
        cfg.map.analytics.enabled = cfg.analytics.enabled ? cfg.map.analytics.enabled : false;
        if (cfg.map.analytics.enabled)
          log("Setting maps tracking");
        vars.document.ready(() => {
          setup(jQuery(cfg.map.blockSelector));
          mutation.addHandler("addNode", cfg.map.blockSelector, setup);
        });
      }
      vars.map.init = true;
    };
    const setup = (elems) => {
      if (elems.length) {
        elems.each(function(block) {
          log("Setting up " + elems.length + " maps", elems);
          let settings, styles, items;
          try {
            settings = JSON.parse(jQuery(elems[block]).attr("data-settings"));
          } catch (e) {
            warn("Map element has invalid JSON settings", elems[block]);
            return;
          }
          if (!settings?.google_maps_display_settings) {
            warn("Map element is missing google_maps_display_settings", elems[block]);
            return;
          }
          try {
            styles = JSON.parse(settings.google_maps_display_settings.snazzy_maps_styles);
          } catch (e) {
            styles = [];
          }
          try {
            items = JSON.parse(jQuery(elems[block]).attr("data-items"));
            if (!Array.isArray(items))
              items = [];
          } catch (e) {
            warn("Map element has invalid JSON items", elems[block]);
            return;
          }
          const lqxMap = {
            map: null,
            options: {
              mapTypeId: settings.google_maps_display_settings.type_of_map,
              scrollWheel: settings.google_maps_display_settings.enable_zoom == "y" ? true : false,
              mapTypeControl: false,
              panControl: settings.google_maps_display_settings.enable_pan == "y" ? true : false,
              zoomControl: settings.google_maps_display_settings.enable_zoom == "y" ? true : false,
              gestureHandling: settings.google_maps_display_settings.enable_pan == "y" ? "normal" : "none",
              streetViewControl: false,
              fullscreenControl: false,
              styles,
              zoom: parseInt(settings.google_maps_display_settings.default_zoom_level)
            },
            center: new google.maps.LatLng(0, 0),
            bounds: new google.maps.LatLngBounds,
            items,
            infoWindows: {},
            markers: {},
            openInfoWindow: null,
            groupedItems: [],
            settings: JSON.parse(jQuery(elems[block]).attr("data-settings"))
          };
          lqxMap.options.mapTypeId = google.maps.MapTypeId[lqxMap.options.mapTypeId];
          const mapSelector = jQuery(elems[block]).find(".map").attr("id");
          lqxMap.map = new google.maps.Map(document.getElementById(mapSelector), lqxMap.options, lqxMap.options);
          for (let i = 0;i < lqxMap.items.length; i++) {
            const itemLatLon = new google.maps.LatLng(lqxMap.items[i].lat, lqxMap.items[i].lon);
            lqxMap.bounds.extend(itemLatLon);
            const itemid = lqxMap.items[i].item_id;
            if (lqxMap.items[i].infoWindow == "true")
              lqxMap.infoWindows[itemid] = new google.maps.InfoWindow({ content: lqxMap.items[i].html });
            const infoWindowHTML = lqxMap.items[i].html;
            const markerParams = {
              position: itemLatLon,
              map: lqxMap.map,
              title: lqxMap.items[i].title,
              html: infoWindowHTML,
              icon: lqxMap.items[i].icon
            };
            if (lqxMap.items[i].icon) {
              markerParams.icon = {
                url: lqxMap.items[i].icon
              };
            }
            lqxMap.markers[itemid] = new google.maps.Marker(markerParams);
            if (lqxMap.items[i].infoWindow == "true") {
              google.maps.event.addListener(lqxMap.markers[itemid], "click", function() {
                if (lqxMap.openInfoWindow !== null) {
                  lqxMap.openInfoWindow.close();
                }
                lqxMap.openInfoWindow = lqxMap.infoWindows[itemid];
                lqxMap.infoWindows[itemid].setContent(this.html);
                lqxMap.infoWindows[itemid].open(lqxMap.map, this);
              });
            }
          }
          lqxMap.map.fitBounds(lqxMap.bounds);
          lqxMap.map.panToBounds(lqxMap.bounds);
          google.maps.event.addListenerOnce(lqxMap.map, "idle", () => {
            lqxMap.map.setZoom(lqxMap.options.zoom);
          });
          vars.map.maps.push(lqxMap);
        });
      }
    };
    const getLocation = function(currentLocation = false) {
      if (currentLocation == false) {
        const geocoder = new google.maps.Geocoder;
        geocoder.geocode({ address: vars.regions.searchQuery, region: "us" }, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            searchLocations(results[0].geometry.location.lat(), results[0].geometry.location.lng());
          }
        });
      } else {
        navigator.geolocation.getCurrentPosition(function(loc) {
          lqx.log("navigator.done ", loc.coords.latitude, loc.coords.longitude);
          const searchQueryEl = jQuery(cfg.regions.searchSelector);
          searchQueryEl.attr("data-lat", loc.coords.latitude);
          searchQueryEl.attr("data-lon", loc.coords.longitude);
          searchLocations(loc.coords.latitude, loc.coords.longitude);
        });
      }
    };
    const searchLocations = function(lat1, lon1) {
      var locdis = [];
      const filterMiles = parseInt(jQuery(cfg.regions.milesSelector).val());
      vars.regions.map.bounds = new google.maps.LatLngBounds;
      const itemLatLon = new google.maps.LatLng(lat1, lon1);
      const deg2rad = function(deg) {
        return deg * (Math.PI / 180);
      };
      vars.regions.map.bounds.extend(itemLatLon);
      jQuery(cfg.regions.searchSelector).attr("data-lat", lat1);
      jQuery(cfg.regions.searchSelector).attr("data-lon", lon1);
      jQuery(vars.regions.mapItems).each(function(index) {
        var lat2 = jQuery(this).attr("data-lat");
        var lon2 = jQuery(this).attr("data-lon");
        var R = 3963.1676;
        var dLat = deg2rad(lat2 - lat1);
        var dLon = deg2rad(lon2 - lon1);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        jQuery(this).attr("data-distance", d);
        jQuery(this).find(".distance").html(" (" + d.toFixed(1) + " miles)");
        var type = jQuery(".menu-shared li.active").attr("data-key");
        var newHref = "http://maps.google.com/maps?saddr=" + lat1 + "," + lon1 + "&daddr=" + lat2 + "," + lon2;
        jQuery(this).find("a.get-direction").attr("href", newHref);
        if (d > parseFloat(filterMiles)) {
          jQuery(this).hide();
          vars.regions.map.markers[jQuery(this).attr("data-marker-index")].setVisible(false);
        } else {
          jQuery(this).show();
          var itemLatLon2 = new google.maps.LatLng(lat2, lon2);
          vars.regions.map.bounds.extend(itemLatLon2);
          vars.regions.map.markers[jQuery(this).attr("data-marker-index")].setVisible(true);
        }
      });
      var list = jQuery(".regions .office-list");
      var items = list.children("li");
      items.sort(function(a, b) {
        return jQuery(a).data("distance") - jQuery(b).data("distance");
      });
      list.append(items);
      vars.regions.map.fitBounds(vars.regions.map.bounds);
      vars.regions.map.setCenter(new google.maps.LatLng(lat1, lon1));
      if (vars.searchMarker) {
        vars.searchMarker.setMap(null);
      }
      vars.regions.searchMarker = new google.maps.Marker({
        position: new google.maps.LatLng(lat1, lon1),
        map: vars.regions.map,
        icon: {
          path: "M 125,5 155,90 245,90 175,145 200,230 125,180 50,230 75,145 5,90 95,90 z",
          fillColor: "gold",
          fillOpacity: 1,
          scale: 0.1,
          strokeColor: "goldenrod",
          strokeWeight: 2
        }
      });
    };
    let updateItems = function(items) {
      let target = vars.map.maps[0];
      Object.keys(target.markers).forEach(function(marker) {
        target.markers[marker].setMap(null);
      });
      target.markers = {};
      target.bounds = new google.maps.LatLngBounds;
      target.items = items;
      target.infoWindows = {};
      target.items.forEach(function(item) {
        const itemLatLon = new google.maps.LatLng(item.lat, item.lon);
        target.bounds.extend(itemLatLon);
        const itemid = item.id;
        if (item.infoWindow == "true")
          target.infoWindows[itemid] = new google.maps.InfoWindow({ content: item.html });
        const infoWindowHTML = item.html;
        const markerParams = {
          position: itemLatLon,
          map: target.map,
          title: item.title,
          html: infoWindowHTML,
          icon: target.settings["google_maps_display_settings"]["pin_override"].url
        };
        target.markers[itemid] = new google.maps.Marker(markerParams);
        if (item.infoWindow == "true") {
          google.maps.event.addListener(target.markers[itemid], "click", function() {
            if (target.openInfowWindow !== null) {
              target.openInfowWindow.close();
            }
            target.openInfowWindow = target.infoWindows[itemid];
            target.infoWindows[itemid].setContent(item.html);
            target.infoWindows[itemid].open(target.map, target.markers[itemid]);
          });
        }
      });
      target.map.fitBounds(target.bounds);
      target.map.panToBounds(target.bounds);
    };
    return {
      init,
      setup,
      getLocation,
      updateItems
    };
  })();

  // ../lyquix/js/lib/lyquix/modal.ts
  var modal = (() => {
    const init = (customCfg) => {
      if (vars.modal?.init)
        return;
      vars.modal = {};
      cfg.modal = {
        enabled: true,
        modalModuleSelector: "#lqx-module-modal > .modal",
        analytics: {
          enabled: true,
          nonInteraction: true,
          onOpen: true,
          onClose: true
        }
      };
      if (customCfg)
        cfg.modal = jQuery.extend(true, cfg.modal, customCfg);
      if (cfg.modal.enabled) {
        log("Initializing `modal`");
        cfg.modal.analytics.enabled = cfg.analytics.enabled ? cfg.modal.analytics.enabled : false;
        if (cfg.modal.analytics.enabled)
          log("Setting modal tracking");
        vars.document.ready(function() {
          setup();
        });
      }
      vars.modal.init = true;
    };
    const setup = function() {
      jQuery.ajax({
        cache: false,
        data: {},
        dataType: "json",
        error: function(xhr, status, errorMsg) {
          error("There has been an error trying to fetch modals from site options", status, errorMsg);
        },
        success: (data) => {
          if (data.length > 0) {
            log("Setting up modals");
            const now = new Date().getTime();
            data.forEach((rawModal) => {
              const m = util.validateData(rawModal, {
                type: "object",
                keys: {
                  id: util.schemaStrReqNotEmp,
                  heading: util.schemaStrReqEmp,
                  body: util.schemaStrReqEmp,
                  expiration: util.schemaStrReqEmp,
                  display_logic: { type: "string", required: true, default: "show", allowed: ["show", "hide"] },
                  display_exceptions: {
                    type: "array",
                    required: true,
                    default: [],
                    elems: {
                      type: "object",
                      keys: {
                        url_pattern: util.schemaStrReqEmp
                      }
                    }
                  },
                  css_classes: util.schemaStrReqEmp,
                  heading_style: { type: "string", required: true, default: "h3", allowed: ["p", "h1", "h2", "h3", "h4", "h5", "h6"] },
                  show_delay: util.schemaStrReqEmp,
                  hide_delay: util.schemaStrReqEmp,
                  dismiss_duration: util.schemaStrReqEmp,
                  links: {
                    type: "array",
                    required: true,
                    default: [],
                    elems: {
                      type: "object",
                      keys: {
                        type: { type: "string", required: true, default: "readmore", allowed: ["button", "readmore"] },
                        link: {
                          type: "object",
                          required: true,
                          default: {},
                          keys: {
                            url: util.schemaStrReqEmp,
                            target: util.schemaStrReqEmp,
                            title: util.schemaStrReqEmp
                          }
                        }
                      }
                    }
                  }
                }
              });
              if (!m || !m.isValid) {
                warn2("Invalid modal data, skipping", rawModal);
                return;
              }
              const modal2 = m.data;
              if (util.cookie(modal2.id) !== null)
                return;
              if (modal2.expiration != "" && now > dayjs(modal2.expiration).valueOf())
                return;
              if (!modal2.heading && !modal2.body)
                return;
              let display = true;
              if (modal2.display_logic == "hide")
                display = false;
              if (Array.isArray(modal2.display_exceptions)) {
                modal2.display_exceptions.forEach((e) => {
                  const url_pattern = e.url_pattern.replace(/[.+?{}()|[\]\\]/g, "\\$&").replace("*", ".*");
                  const regex = new RegExp("^" + url_pattern + "$");
                  if (regex.test(window.location.pathname))
                    display = !display;
                });
              }
              if (!display)
                return;
              let html = `<dialog
\t\t\t\t\t\t\tid="${modal2.id}"
\t\t\t\t\t\t\tclass="${modal2.css_classes}"
\t\t\t\t\t\t\tdata-heading-style="${modal2.heading_style}"
\t\t\t\t\t\t\tdata-show-delay="${modal2.show_delay}"
\t\t\t\t\t\t\tdata-hide-delay="${modal2.hide_delay}"
\t\t\t\t\t\t\tdata-dismiss-duration="${modal2.dismiss_duration}"
\t\t\t\t\t\t\taria-labeledby="${modal2.id}-title"
\t\t\t\t\t\t\taria-describedby aria-modal="true" aria-hidden="true">`;
              html += '<button class="close">Close</button>';
              if (modal2.heading) {
                html += modal2.heading_style == "p" ? `<p class="title" id="${modal2.id}-title"><strong>` : `<${modal2.heading_style} id="${modal2.id}-title">`;
                html += modal2.heading;
                html += modal2.heading_style == "p" ? "</strong></p>" : `</${modal2.heading_style}>`;
              }
              html += modal2.body;
              if (modal2.links.length) {
                html += '<ul class="links">';
                modal2.links.forEach((l) => {
                  if (l.link.url) {
                    html += "<li>";
                    html += `<a href="${l.link.url}" class="${l.type == "button" ? "button" : "readmore"}" ${l.link.target ? ' target="_blank"' : ""}>`;
                    html += l.link.title ? l.link.title : "Read More";
                    html += "</a>";
                    html += "</li>";
                  }
                });
                html += "</ul>";
              }
              html += "</dialog>";
              const modalElem = jQuery(html).appendTo(vars.body);
              log("Modal added", modalElem);
              if (isNaN(modal2.show_delay))
                open(modal2.id);
              else if (parseInt(modal2.show_delay) > 0) {
                window.setTimeout(() => {
                  open(modal2.id);
                }, parseInt(modal2.show_delay) * 1000);
              }
              modalElem.find(".close").click(() => {
                close(modal2.id);
              });
              modalElem.on("close", () => {
                close(modal2.id);
              });
            });
            if (!jQuery("[id^=modal-]").length) {
              log("All modals were expired or closed");
            }
          } else {
            log("No modals to show");
          }
        },
        url: cfg.siteURL + "/wp-json/lyquix/v3/modal"
      });
    };
    const open = (modalId) => {
      const modalElem = jQuery("#" + modalId);
      if (!modalElem.length) {
        warn2("Modal element not found", modalId);
        return;
      }
      modalElem.get(0).showModal();
      modalElem.attr("aria-hidden", "false");
      log("Modal opened");
      const hideDelay = modalElem.attr("data-hide-delay");
      if (hideDelay !== "" && !isNaN(hideDelay)) {
        window.setTimeout(() => {
          close(modalId);
        }, parseInt(hideDelay) * 1000);
      }
      if (cfg.modal.analytics.enabled && cfg.modal.analytics.onOpen) {
        const headingStyle = modalElem.attr("data-heading-style") || "h3";
        const heading = modalElem.find(headingStyle == "p" ? "p.title strong" : headingStyle).text();
        analytics.sendGAEvent({
          eventCategory: "Modal",
          eventAction: "Open",
          eventLabel: heading,
          nonInteraction: cfg.modal.analytics.nonInteraction
        });
      }
    };
    const close = (modalId) => {
      const modalElem = jQuery("#" + modalId);
      if (!modalElem.length) {
        warn2("Modal element not found", modalId);
        return;
      }
      if (modalElem.attr("open") === undefined)
        return;
      const dismissDuration = modalElem.attr("data-dismiss-duration");
      util.cookie(modalId, "1", {
        path: "/",
        maxAge: dismissDuration ? dismissDuration * 60 : 60 * 60 * 24 * 365
      });
      modalElem.get(0).close();
      modalElem.attr("aria-hidden", "true");
      log("Modal closed");
      if (cfg.modal.analytics.enabled && cfg.modal.analytics.onClose) {
        const headingStyle = modalElem.attr("data-heading-style") || "h3";
        const heading = modalElem.find(headingStyle == "p" ? "p.title strong" : headingStyle).text();
        analytics.sendGAEvent({
          eventCategory: "Modal",
          eventAction: "Close",
          eventLabel: heading,
          nonInteraction: cfg.modal.analytics.nonInteraction
        });
      }
    };
    return {
      init,
      open,
      close
    };
  })();

  // ../lyquix/js/lib/lyquix/popup.ts
  var popup = (() => {
    const init = (customCfg) => {
      if (vars.popup?.init)
        return;
      vars.popup = {};
      cfg.popup = {
        enabled: true,
        popupModuleSelector: "#lqx-module-popup > .popup",
        analytics: {
          enabled: true,
          nonInteraction: true,
          onOpen: true,
          onClose: true
        }
      };
      if (customCfg)
        cfg.popup = jQuery.extend(true, cfg.popup, customCfg);
      if (cfg.popup.enabled) {
        log("Initializing `popup`");
        cfg.popup.analytics.enabled = cfg.analytics.enabled ? cfg.popup.analytics.enabled : false;
        if (cfg.popup.analytics.enabled)
          log("Setting popup tracking");
        vars.document.ready(function() {
          setup();
        });
      }
      vars.popup.init = true;
    };
    const setup = function() {
      const popupModuleElem = jQuery(cfg.popup.popupModuleSelector);
      if (popupModuleElem.length == 0)
        return;
      log("Setting up popups", popupModuleElem);
      jQuery.ajax({
        cache: false,
        data: {},
        dataType: "json",
        error: function(xhr, status, errorMsg) {
          error("There has been an error trying to fetch popups from site options", status, errorMsg);
        },
        success: (data) => {
          if (data.length > 0) {
            const now = new Date().getTime();
            data.forEach((rawPopup) => {
              const p = util.validateData(rawPopup, {
                type: "object",
                keys: {
                  id: util.schemaStrReqNotEmp,
                  heading: util.schemaStrReqEmp,
                  body: util.schemaStrReqEmp,
                  expiration: util.schemaStrReqEmp,
                  display_logic: { type: "string", required: true, default: "show", allowed: ["show", "hide"] },
                  display_exceptions: {
                    type: "array",
                    required: true,
                    default: [],
                    elems: {
                      type: "object",
                      keys: {
                        url_pattern: util.schemaStrReqEmp
                      }
                    }
                  },
                  css_classes: util.schemaStrReqEmp,
                  heading_style: { type: "string", required: true, default: "h3", allowed: ["p", "h1", "h2", "h3", "h4", "h5", "h6"] },
                  show_delay: util.schemaStrReqEmp,
                  hide_delay: util.schemaStrReqEmp,
                  dismiss_duration: util.schemaStrReqEmp,
                  links: {
                    type: "array",
                    required: true,
                    default: [],
                    elems: {
                      type: "object",
                      keys: {
                        type: { type: "string", required: true, default: "readmore", allowed: ["button", "readmore"] },
                        link: {
                          type: "object",
                          required: true,
                          default: {},
                          keys: {
                            url: util.schemaStrReqEmp,
                            target: util.schemaStrReqEmp,
                            title: util.schemaStrReqEmp
                          }
                        }
                      }
                    }
                  }
                }
              });
              if (!p || !p.isValid) {
                warn2("Invalid popup data, skipping", rawPopup);
                return;
              }
              const popup2 = p.data;
              if (util.cookie(popup2.id) !== null)
                return;
              if (popup2.expiration != "" && now > dayjs(popup2.expiration).valueOf())
                return;
              if (!popup2.heading && !popup2.body)
                return;
              let display = true;
              if (popup2.display_logic == "hide")
                display = false;
              if (Array.isArray(popup2.display_exceptions)) {
                popup2.display_exceptions.forEach((e) => {
                  const url_pattern = e.url_pattern.replace(/[.+?{}()|[\]\\]/g, "\\$&").replace("*", ".*");
                  const regex = new RegExp("^" + url_pattern + "$");
                  if (regex.test(window.location.pathname))
                    display = !display;
                });
              }
              if (!display)
                return;
              let html = `<section
\t\t\t\t\t\t\tid="${popup2.id}"
\t\t\t\t\t\t\tclass="closed ${popup2.css_classes}"
\t\t\t\t\t\t\tdata-heading-style="${popup2.heading_style}"
\t\t\t\t\t\t\tdata-show-delay="${popup2.show_delay}"
\t\t\t\t\t\t\tdata-hide-delay="${popup2.hide_delay}"
\t\t\t\t\t\t\tdata-dismiss-duration="${popup2.dismiss_duration}">`;
              html += '<button class="close">Close</button>';
              if (popup2.heading) {
                html += popup2.heading_style == "p" ? '<p class="title"><strong>' : `<${popup2.heading_style}>`;
                html += popup2.heading;
                html += popup2.heading_style == "p" ? "</strong></p>" : `</${popup2.heading_style}>`;
              }
              html += popup2.body;
              if (popup2.links.length) {
                html += '<ul class="links">';
                popup2.links.forEach((l) => {
                  if (l.link.url) {
                    html += "<li>";
                    html += `<a href="${l.link.url}" class="${l.type == "button" ? "button" : "readmore"}" ${l.link.target ? ' target="_blank"' : ""}>`;
                    html += l.link.title ? l.link.title : "Read More";
                    html += "</a>";
                    html += "</li>";
                  }
                });
                html += "</ul>";
              }
              html += "</section>";
              const popupElem = jQuery(html).appendTo(popupModuleElem);
              log("Popup added", popupElem);
              if (isNaN(popup2.show_delay))
                open(popup2.id);
              else if (parseInt(popup2.show_delay) > 0) {
                window.setTimeout(() => {
                  open(popup2.id);
                }, parseInt(popup2.show_delay) * 1000);
              }
              popupElem.find(".close").click(() => {
                close(popup2.id);
              });
            });
            if (!popupModuleElem.children().length) {
              popupModuleElem.remove();
              log("All popups were expired or closed");
            }
          } else {
            popupModuleElem.remove();
            log("No popups to show");
          }
        },
        url: cfg.siteURL + "/wp-json/lyquix/v3/popup"
      });
    };
    const open = (popupId) => {
      const popupElem = jQuery("#" + popupId);
      if (!popupElem.length) {
        warn2("Popup element not found", popupId);
        return;
      }
      popupElem.removeClass("closed");
      log("Popup opened");
      const hideDelay = popupElem.attr("data-hide-delay");
      if (hideDelay !== "" && !isNaN(hideDelay)) {
        window.setTimeout(() => {
          close(popupId);
        }, parseInt(hideDelay) * 1000);
      }
      if (cfg.popup.analytics.enabled && cfg.popup.analytics.onOpen) {
        const headingStyle = popupElem.attr("data-heading-style") || "h3";
        const heading = popupElem.find(headingStyle == "p" ? "p.title strong" : headingStyle).text();
        analytics.sendGAEvent({
          eventCategory: "Popup",
          eventAction: "Open",
          eventLabel: heading,
          nonInteraction: cfg.popup.analytics.nonInteraction
        });
      }
    };
    const close = (popupId) => {
      const popupElem = jQuery("#" + popupId);
      if (!popupElem.length) {
        warn2("Popup element not found", popupId);
        return;
      }
      if (popupElem.hasClass("closed"))
        return;
      const dismissDuration = popupElem.attr("data-dismiss-duration");
      util.cookie(popupId, "1", {
        path: "/",
        maxAge: dismissDuration ? dismissDuration * 60 : 60 * 60 * 24 * 365
      });
      popupElem.addClass("closed");
      log("Popup closed");
      if (cfg.popup.analytics.enabled && cfg.popup.analytics.onClose) {
        const headingStyle = popupElem.attr("data-heading-style") || "h3";
        const heading = popupElem.find(headingStyle == "p" ? "p.title strong" : headingStyle).text();
        analytics.sendGAEvent({
          eventCategory: "Popup",
          eventAction: "Close",
          eventLabel: heading,
          nonInteraction: cfg.popup.analytics.nonInteraction
        });
      }
    };
    return {
      init,
      open,
      close
    };
  })();

  // ../lyquix/js/lib/lyquix/tabs.ts
  var tabs = (() => {
    const init = (customCfg) => {
      if (vars.tabs?.init)
        return;
      vars.tabs = {
        init: false
      };
      cfg.tabs = {
        enabled: true,
        tabsSelector: ".lqx-block-tabs > .tabs",
        tabsListSelector: ".tabs-list",
        tabSelector: ".tab",
        tabPanelSelector: ".tab-panel",
        headerSelector: ".accordion-header",
        subheadingSelector: ".accordion-subheading",
        tabContentSelector: ".tab-content",
        analytics: {
          enabled: true,
          nonInteraction: true
        }
      };
      if (customCfg)
        cfg.tabs = jQuery.extend(true, cfg.tabs, customCfg);
      if (cfg.tabs.enabled) {
        log("Initializing tabs");
        cfg.tabs.analytics.enabled = cfg.analytics.enabled ? cfg.tabs.analytics.enabled : false;
        if (cfg.tabs.analytics.enabled)
          log("Setting tabs tracking");
        vars.document.ready(() => {
          setup(jQuery(cfg.tabs.tabsSelector));
          mutation.addHandler("addNode", cfg.tabs.tabsSelector, setup);
        });
      }
      vars.tabs.init = true;
    };
    const setup = (elems) => {
      if (elems.length) {
        log("Setting up " + elems.length + " tabs", elems);
        elems.each((idx, tabsElem) => {
          tabsElem = jQuery(tabsElem);
          tabsElem.find(cfg.tabs.tabSelector).each((idx2, tabElem) => {
            tabElem = jQuery(tabElem);
            const panelId = tabElem.attr("id").replace("-tab-", "-panel-");
            if (!jQuery("#" + panelId).length) {
              warn2("Tab panel element not found", panelId);
              return;
            }
            jQuery(tabElem).on("click", () => {
              open(panelId);
            });
          });
          const accordionScreens = (tabsElem.attr("data-convert-to-accordion") || "").split(",").filter((x) => ["xs", "sm", "md", "lg", "xl"].includes(x));
          if (accordionScreens.length) {
            const accordionTabsSwitch = () => {
              if (accordionScreens.includes(responsive.screen)) {
                tabsElem.find(cfg.tabs.tabPanelSelector).each((idx2, panelElem) => {
                  if (jQuery(panelElem).attr("aria-hidden") !== "false") {
                    jQuery(panelElem).find(cfg.tabs.tabContentSelector).attr("aria-hidden", "true");
                  } else {
                    jQuery(panelElem).find(cfg.tabs.tabContentSelector).attr("aria-hidden", "false");
                  }
                });
                tabsElem.find(cfg.tabs.tabsListSelector).attr("aria-hidden", "true");
                tabsElem.find(cfg.tabs.headerSelector).attr("aria-hidden", "false");
                tabsElem.find(cfg.tabs.subheadingSelector).attr("aria-hidden", "false");
              } else {
                tabsElem.find(cfg.tabs.tabsListSelector).attr("aria-hidden", "false");
                tabsElem.find(cfg.tabs.headerSelector).attr("aria-hidden", "true");
                tabsElem.find(cfg.tabs.subheadingSelector).attr("aria-hidden", "true");
                tabsElem.find(cfg.tabs.tabPanelSelector).each((idx2, panelElem) => {
                  if (jQuery(panelElem).find(cfg.tabs.tabContentSelector).attr("aria-hidden") == undefined || jQuery(panelElem).find(cfg.tabs.tabContentSelector).attr("aria-hidden") == "") {
                    if (idx2 == 0) {
                      jQuery(panelElem).find(cfg.tabs.tabContentSelector).attr("aria-hidden", "false");
                    } else {
                      jQuery(panelElem).find(cfg.tabs.tabContentSelector).attr("aria-hidden", "true");
                    }
                  }
                  if (jQuery(panelElem).find(cfg.tabs.tabContentSelector).attr("aria-hidden") !== "false") {
                    jQuery(panelElem).attr("aria-hidden", "true");
                  } else {
                    jQuery(panelElem).attr("aria-hidden", "false");
                  }
                });
              }
            };
            vars.window.on("screensizechange", accordionTabsSwitch);
            accordionTabsSwitch();
            tabsElem.find(cfg.tabs.headerSelector).each((idx2, headerElem) => {
              headerElem = jQuery(headerElem);
              const panelId = headerElem.attr("id").replace("-header-", "-panel-");
              const panelElem = jQuery("#" + headerElem.attr("id").replace("-header-", "-content-"));
              jQuery(headerElem).on("click", () => {
                if (panelElem.attr("aria-hidden") === "true")
                  open(panelId);
                else
                  close(panelId);
              });
            });
          }
        });
      }
    };
    const open = (panelId) => {
      log("Opening tab", panelId);
      const panelElem = jQuery("#" + panelId);
      const tabElem = jQuery("#" + panelId.replace("-panel-", "-tab-"));
      const tabsElem = panelElem.parent();
      if (!panelElem.length || !tabElem.length) {
        warn2("Tab panel or tab element not found", panelId);
        return;
      }
      panelElem.attr("aria-hidden", "false");
      tabElem.attr("tabindex", "");
      tabElem.attr("aria-selected", "true");
      const accordionScreens = (tabsElem.attr("data-convert-to-accordion") || "").split(",").filter((x) => ["xs", "sm", "md", "lg", "xl"].includes(x));
      if (accordionScreens.includes(responsive.screen)) {
        const headerElem = jQuery("#" + panelId.replace("-panel-", "-header-"));
        const contentElem = jQuery("#" + panelId.replace("-panel-", "-content-"));
        if (headerElem.length && contentElem.length) {
          contentElem.attr("aria-hidden", "false");
          headerElem.attr("aria-expanded", "true");
        }
      }
      const autoScrollScreens = (tabsElem.attr("data-auto-scroll") || "").split(",").filter((x) => ["xs", "sm", "md", "lg", "xl"].includes(x));
      if (autoScrollScreens.includes(responsive.screen)) {
      }
      if (tabsElem.attr("data-browser-history") == "y") {
      }
      tabsElem.find(cfg.tabs.tabPanelSelector).not(panelElem).each((idx, elem) => {
        close(jQuery(elem).attr("id"));
      });
      if (cfg.tabs.analytics.enabled) {
        analytics.sendGAEvent({
          eventCategory: "tabs",
          eventAction: "Open",
          eventLabel: tabElem.text(),
          nonInteraction: cfg.tabs.analytics.nonInteraction
        });
      }
    };
    const close = (panelId) => {
      log("Closing tab", panelId);
      const panelElem = jQuery("#" + panelId);
      const tabElem = jQuery("#" + panelId.replace("-panel-", "-tab-"));
      const tabsElem = panelElem.parent();
      if (!panelElem.length || !tabElem.length) {
        warn2("Tab panel or tab element not found", panelId);
        return;
      }
      panelElem.attr("aria-hidden", "true");
      tabElem.attr("tabindex", "-1");
      tabElem.attr("aria-selected", "false");
      const accordionScreens = (tabsElem.attr("data-convert-to-accordion") || "").split(",").filter((x) => ["xs", "sm", "md", "lg", "xl"].includes(x));
      if (accordionScreens.includes(responsive.screen)) {
        const headerElem = jQuery("#" + panelId.replace("-panel-", "-header-"));
        const contentElem = jQuery("#" + panelId.replace("-panel-", "-content-"));
        if (headerElem.length && contentElem.length) {
          contentElem.attr("aria-hidden", "true");
          headerElem.attr("aria-expanded", "false");
        }
      }
      if (cfg.tabs.analytics.enabled && cfg.tabs.analytics.onClose) {
        analytics.sendGAEvent({
          eventCategory: "tabs",
          eventAction: "Close",
          eventLabel: tabElem.text(),
          nonInteraction: cfg.tabs.analytics.nonInteraction
        });
      }
    };
    return {
      init,
      open,
      setup
    };
  })();

  // ../lyquix/js/lib/lyquix/slider.ts
  var slider = (() => {
    const init = (customCfg) => {
      if (vars.slider?.init)
        return;
      vars.slider = {
        slider: []
      };
      cfg.slider = {
        enabled: true,
        sliderBlockSelector: ".lqx-block-slider > .slider",
        swiperWrapperSelector: ".swiper-wrapper",
        swiperSelector: ".swiper",
        swiperSlideClass: "swiper-slide",
        swiperNextSelector: ".swiper-button-next",
        swiperPrevSelector: ".swiper-button-prev",
        swiperPaginationSelector: ".swiper-pagination",
        analytics: {
          enabled: true,
          nonInteraction: true,
          onPrevNext: true
        }
      };
      if (customCfg)
        cfg.slider = jQuery.extend(true, cfg.slider, customCfg);
      if (cfg.slider.enabled) {
        log("Initializing `slider`");
        cfg.slider.analytics.enabled = cfg.analytics.enabled ? cfg.slider.analytics.enabled : false;
        if (cfg.slider.analytics.enabled)
          log("Setting slider analytics");
        vars.document.ready(function() {
          setup(jQuery(cfg.slider.sliderBlockSelector));
          mutation.addHandler("addNode", cfg.slider.sliderBlockSelector, setup);
        });
      }
      vars.slider.init = true;
    };
    const setup = (elems) => {
      if (elems.length) {
        log("Setting up " + elems.length + " sliders", elems);
        elems.each((idx, sliderElem) => {
          sliderElem = jQuery(sliderElem);
          const autoplay = sliderElem.attr("data-autoplay") === "y";
          const autoplayDelay = parseInt(sliderElem.attr("data-autoplay-delay")) || 15;
          const loop = sliderElem.attr("data-loop") === "y";
          const pagination = sliderElem.attr("data-pagination") === "y";
          const navigation = sliderElem.attr("data-navigation") === "y";
          let swiperOptions = {
            direction: "horizontal",
            loop,
            slidesPerView: 1
          };
          if (autoplay == true) {
            swiperOptions["autoplay"] = {
              delay: autoplayDelay * 1000,
              pauseOnMouseEnter: true
            };
          }
          if (pagination == true) {
            swiperOptions["pagination"] = {
              enabled: true,
              el: cfg.slider.swiperPaginationSelector,
              clickable: true,
              renderBullet(index, className) {
                const slideEl = this.slides[index];
                const teaserText = slideEl.getAttribute("data-slide-teaser");
                const thumbnail = slideEl.getAttribute("data-slide-thumbnail");
                return `<span class="${className}" role="button" aria-label="Go to slide ${index + 1}">` + (thumbnail ? `<img src="${thumbnail}" alt="" />` : teaserText) + "</span>";
              }
            };
          }
          if (navigation == true) {
            swiperOptions["navigation"] = {
              enabled: true,
              prevEl: cfg.slider.swiperPrevSelector,
              nextEl: cfg.slider.swiperNextSelector
            };
          }
          const swiperOptionsOverride = sliderElem.attr("data-swiper-options-override");
          if (swiperOptionsOverride) {
            try {
              swiperOptions = jQuery.extend(true, swiperOptions, JSON.parse(swiperOptionsOverride));
            } catch (e) {
              warn2("Swiper options override is not valid JSON");
            }
          }
          new Swiper("#" + sliderElem.attr("id") + " " + cfg.slider.swiperSelector, swiperOptions);
          if (navigation == true) {
            sliderElem.find(cfg.slider.swiperPrevSelector).click(() => {
              if (cfg.slider.analytics.enabled && cfg.slider.analytics.onPrevNext) {
                analytics.sendGAEvent({
                  eventCategory: "Slider",
                  eventAction: "Previous",
                  eventLabel: "",
                  nonInteraction: cfg.slider.analytics.nonInteraction
                });
              }
            });
            sliderElem.find(cfg.slider.swiperNextSelector).click(() => {
              if (cfg.slider.analytics.enabled && cfg.slider.analytics.onPrevNext) {
                analytics.sendGAEvent({
                  eventCategory: "Slider",
                  eventAction: "Next",
                  eventLabel: "",
                  nonInteraction: cfg.slider.analytics.nonInteraction
                });
              }
            });
          }
        });
      }
    };
    return {
      init
    };
  })();

  // ../lyquix/js/lib/lyquix/testimonial.ts
  var testimonial = (() => {
    const init = (customCfg) => {
      if (vars.testimonial?.init)
        return;
      vars.testimonial = {};
      cfg.testimonial = {
        enabled: true,
        testimonialBlockSelector: ".lqx-block-testimonial > .testimonial",
        swiperWrapperSelector: ".swiper-wrapper",
        swiperSelector: ".swiper",
        swiperSlideClass: "swiper-slide",
        swiperNextSelector: ".swiper-button-next",
        swiperPrevSelector: ".swiper-button-prev",
        analytics: {
          enabled: true,
          nonInteraction: true,
          onPrevNext: true
        }
      };
      if (customCfg)
        cfg.testimonial = jQuery.extend(true, cfg.testimonial, customCfg);
      if (cfg.testimonial.enabled) {
        log("Initializing `testimonial`");
        cfg.testimonial.analytics.enabled = cfg.analytics.enabled ? cfg.testimonial.analytics.enabled : false;
        if (cfg.testimonial.analytics.enabled)
          log("Setting testimonial analytics");
        vars.document.ready(() => {
          setup(jQuery(cfg.testimonial.testimonialBlockSelector));
          mutation.addHandler("addNode", cfg.testimonial.testimonialBlockSelector, setup);
        });
      }
      vars.testimonial.init = true;
    };
    const setup = (elems) => {
      if (elems.length) {
        log("Setting up " + elems.length + " galleries", elems);
        elems.each((idx, testimonialElem) => {
          testimonialElem = jQuery(testimonialElem);
          if (testimonialElem.find(cfg.testimonial.swiperSelector).length == 0)
            return;
          let swiperOptions = {
            direction: "horizontal",
            loop: true,
            slidesPerView: 1,
            navigation: {
              prevEl: cfg.testimonial.swiperPrevSelector,
              nextEl: cfg.testimonial.swiperNextSelector
            }
          };
          try {
            const swiperOptionsOverride = JSON.parse(testimonialElem.attr("data-swiper-options-override"));
            swiperOptions = jQuery.extend(true, swiperOptions, swiperOptionsOverride);
          } catch (e) {
            warn2("Swiper options override is not valid JSON");
          }
          new Swiper("#" + testimonialElem.attr("id") + " " + cfg.testimonial.swiperSelector, swiperOptions);
          testimonialElem.find(`${cfg.testimonial.swiperPrevSelector}, ${cfg.testimonial.swiperNextSelector}`).click((event) => {
            if (cfg.testimonial.analytics.enabled && cfg.testimonial.analytics.onPrevNext) {
              analytics.sendGAEvent({
                eventCategory: "Testimonial",
                eventAction: jQuery(event.target).hasClass(cfg.testimonial.swiperPrevSelector.replace(".", "")) ? "Previous" : "Next",
                eventLabel: "",
                nonInteraction: cfg.testimonial.analytics.nonInteraction
              });
            }
            if (testimonialElem.attr("data-browser-history") == "y") {
            }
          });
        });
      }
    };
    return {
      init
    };
  })();

  // ../lyquix/js/lyquix.ts
  var version = "3.1.0";
  var init = (customCfg) => {
    if (vars.init)
      return;
    if (typeof customCfg !== "object")
      customCfg = {};
    const mods = [
      "mutation",
      "store",
      "util",
      "detect",
      "responsive",
      "analytics",
      "geolocate",
      "swipe",
      "lyqbox",
      "theme",
      "menu",
      "video",
      "accordion",
      "alerts",
      "cards",
      "filters",
      "gallery",
      "map",
      "modal",
      "popup",
      "tabs",
      "slider",
      "testimonial"
    ];
    Object.keys(cfg).forEach((k) => {
      if (k in customCfg)
        cfg[k] = customCfg[k];
    });
    console.log(`%c
` + `██      ▐█          ▐█    ▄█████▄▄    ▐█          █▌  █▌  █▄      ▄█▄
` + `██       ██         ██  ██▀      ▀█▄  ▐█          █▌  █▌   ▀█▄   ██▀
` + `██        ▀█▄▄  ▄▄██▀  █▌          █▌ ▐█          █▌  █▌     ██▄█▀
` + `██           ▀██▀▀     █           ██ ▐█          █▌  █▌     ▄███
` + `▐█▄           ▐█       ▀▌      █  ▄█   ██        ██   █▌   ▄██  ▀█▄
` + `  ▀██▄▄▄▄██▀  ▐█        ▀█▄    ██▄▀     ▀██▄▄▄▄██▀    █▌  ██▀     ▀█▄
` + `      ▀▀                        ▀█
`, "color: #7FA53F");
    const debugLevelMap = ["None", "Errors", "Warnings", "All"];
    console.log(`%cInitializing LYQUIX v${version}
Logging Level: ${cfg.debug} (${debugLevelMap[cfg.debug]})`, "color: #7FA53F; font-size: 1.25em; font-weight: bold");
    log("Custom configuration", customCfg);
    mods.forEach((mod) => {
      lqx[mod].init(mod in customCfg ? customCfg[mod] : {});
    });
    vars.document.trigger("lqxready");
    log("lqxready Event");
    vars.init = true;
  };
  var ready = (callback) => {
    if (vars.init === true) {
      callback();
    } else {
      vars.document.on("lqxready", callback);
    }
  };
  var expObj = Object.defineProperties({
    init,
    ready,
    log,
    warn: warn2,
    error,
    analytics,
    detect,
    geolocate,
    lyqbox,
    mutation,
    responsive,
    store,
    swipe,
    util,
    theme,
    menu,
    video,
    accordion,
    alerts,
    cards,
    filters,
    gallery,
    map,
    modal,
    popup,
    tabs,
    slider,
    testimonial
  }, {
    cfg: {
      get() {
        return cfg;
      },
      set() {
        return;
      }
    },
    vars: {
      get() {
        return vars;
      },
      set() {
        return;
      }
    },
    version: {
      get() {
        return version;
      },
      set() {
        return;
      }
    }
  });
  var lyquix_default = expObj;
  if (typeof window !== "undefined") {
    window.lqx = expObj;
  }
  vars.document.trigger("lqxload");
  log("lqxload Event");
})();
